export default {

  component: {
    federatedLoginError: {
      heading: 'Autentisering mislyktes',
      content: 'Vi kunne ikke logge deg inn. Forsøk igjen senere, og kontakt vår kundestøtte dersom problemet vedvarer.',
    },

    accountMenu: {
      myAccount: 'Min konto',
      billing: 'Fakturering',
      userManagement: 'Brukeradministrasjon',
      organisationProfile: 'Organisasjonsinnstillinger',
      statistics: 'Statistics',
      videos: 'Videobibliotek',
    },

    adminNavigationBar: {
      dashboard: 'Hovedvisning',
      backToMainMenu: 'Tilbake til hovedmenyen',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: 'Ingen handlinger',
      show: 'Vis innhold',
      hide: 'Skjul innhold',
      action: {
        comment: 'kommenterte søknad',
        invite: 'invitert til intervju',
        schedulingInvite: 'sent candidate a scheduling invite',
        reScheduled: 'rescheduled the interview',
        addedCandidateToRound: 'added candidate to interview round',
        selectedInterviewTime: 'Candidate selected interview time',
        reInvite: 'tilbakekaller invitasjonen til kandidaten',
        smsInvite: 'inviterte til intervju via SMS',
        smsReInvite: 'sendte ny invitasjon til kandidaten via SMS',
        videoResponse: 'Kandidaten besvarte videospørsmål',
        message: 'e-post sendt',
        personalInterviewMessage: 'sendte en invitasjon til et planlagt møte',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'videomelding sendt',
        applicationCreatedByAdmin: 'la til denne kandidaten',
        stageChanged: placeholderKeys => `flyttet kandidat til stadie ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `Kandidaten svarte på intervjuet ${placeholder.opening}`,
        applicationCreated: 'Søknad opprettet',
        applicationUpdated: 'Søknad oppdatert',
        candidateUpdated: 'Kandidat oppdatert',
        introductionToOne: placeholders => `Kandidaten ble introdusert til ${placeholders.introducee}`,
        introductionToMany: placeholders => `Kandidaten ble introdusert til ${placeholders.introduceeCount} mottagere`,
        calendarEventCreated: placeholders => `Kandidaten bekreftet møte: ${placeholders.eventStartTime}`,
        addRating: 'la til en vurdering',
        deleteRating: 'slettet vurderingen sin',
        withdrew: 'Kandidaten trakk seg fra prosessen.',
        resetQuestionResponse: 'slettet kandidatens svar.',
        joinedLiveInterview: 'Candidate joined the interview',
        evaluated: 'evaluated the candidate',
      },
      videoLink: {
        linkText: 'Vis innhold',
      },
    },

    additionalFormFields: {
      delete: 'Slette',
      done: 'Ferdig',
      cancel: 'Avbryte',
      edit: 'Rediger',
      required: 'Nødvendig',
      optional: 'Valgfri',
      notAsked: 'Ikke spurt',
      title: 'Ekstra felt i skjemaet',
      add: 'Legg til et nytt felt i skjemaet',
      description: context => (context === 'interview'
        ? 'Ytterligere felt kan ikke slettes etter at invitasjonene er sendt.'
        : 'Ytterligere felt kan ikke slettes hvis stillingen har søknader.'),
      addOption: 'Legg til',
      shortText: 'Kort tekst',
      longText: 'Lang tekst',
      singleSelect: 'Enkelt utvalg',
      multiSelect: 'Flervalg',
      fieldLabelPlaceholder: 'Feltetikett for kandidater',
      fieldNamePlaceholder: 'Feltnavn for rekrutterere',
      addLabel: 'Legg til etikett',
      addName: 'Legg til navn',
      nameLabel: 'Feltetikett',
      typeLabel: 'Felttype',
      optionLabel: 'Feltalternativer',
      settingsLabel: 'Skjemainnstillinger',
      reorder: 'Omgjøre felt',
      stopReordering: 'Stopp omgjøring av felt',
      optionPlaceholder: 'Legg til et alternativ',
      optionError: 'Alternativet eksisterer allerede',
    },

    addPublicQuestions: {
      title: 'Videospørsmål',
      description: 'Legg til søknadens fasespørsmål her.',
    },

    addQuestions: {
      edit: {
        start: 'Endring av rekkefølgen på spørsmålene',
        stop: 'Stopp endring av rekkefølgen på spørsmålene',
      },
      placeholder: isMobile => (isMobile ? 'Klikk for å last opp eller spille inn et spørsmål' : 'Klikk for å spille inn et spørsmål'),
      textQuestionPlaceholder: 'Klikk for å skrive et spørsmål',
      videoPlaceholder: isMobile => (isMobile ? 'Legg til en ny video' : 'Legg til en ny video'),
      library: 'Velg fra bibliotek',
      text: 'Tekstspørsmål',
      record: 'Ta opp',
      upload: 'Last opp',
      answerable: 'Spørsmålet kan besvares',
      required: 'Svar er påkrevd',
      takeLimitLabel: 'Antall innspillingsforsøk',
      answerTimeLabel: 'Besvaringstid',
      preparationTimeLabel: 'Forberedelsestid',
      evaluationCriteriaLabel: 'Vurderingskriterier',
      questionPlaceholder: 'Skriv spørsmålet ditt her',
      evaluationCriteriaPlaceholder: 'Skriv inn vurderingskriterier for spørsmålet her',
      cancel: 'Avbryte',
      add: 'Legg til',
      unlimitedLabel: 'Ubegrenset',
    },

    addVideo: {
      title: 'Arbeidsgivervideo',
      description: 'Markedsføre firmaets bedriftskultur og forsterke arbeidsgiverens merkevarebygging ved å legge til en arbeidsgivervideo med jobbannonsen',
    },

    adminCoverPhoto: {
      welcome: name => `Velkommen, ${name}!`,
      photo: 'Legg til bakgrunnsbilde',
      removePhoto: 'Fjern bakgrunnsbilde',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      termsLink:
        'https://get.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: 'Søknadens skjemaoppsett',
      notAsked: 'Ikke spurt',
      optional: 'Valgfri',
      required: 'Nødvendig',
      name: 'Navn',
      coverLetter: 'Følgebrev',
      email: 'E-post',
      phoneNumber: 'Telefonnummer',
      city: 'By',
      attachments: 'Vedlegg',
      links: 'Lenker',
      questions: 'Videospørsmål',
      attachmentsDescription: 'Beskrivelse for vedlegg',
    },

    billingPlanSelector: {
      select: 'Velg',
      removeSelection: 'Remove selection',
      month: '/måned',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright videointervju',
      'single-recruitment': 'Enkel rekruttering',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Recright tilpasset plan',
      plans: {
        'recright-easy': {
          info: '10 - 20 stillinger per år for små til mellomstore bedrifter for å spare tid på rekruttering.',
          info2: '',
          features: [
            'Over 50 stillinger per år',
            'Ubegrensede brukerplasser',
            'Brukeradministrasjon',
            'Gratis videoopplæring',
            'Merkevarebygging',
            'Kundestøtte',
          ],
          unitType: '/måned',
        },
        'recright-pro2': {
          info: '30 - 50 stillinger per år for større virksomheter med ytterligere merkevare- og administrasjonsbehov.',
          info2: '',
          features: [
            'Alt i Easy, pluss:',
            'Rapportering',
            'Opplæring innen beste praksis',
            'Kundesuksess',
          ],
          unitType: '/måned',
        },
        'recright-ats': {
          features: [
            'Rekrutteringsverktøy',
            'Ubegrenset med jobbannonser',
            'Arbeidsgiver merkevare-video',
            'Video-spørsmål i applikasjonen',
            'Kandidat-vurdering',
            'Kandidat-kommunikasjon',
            'Team-engasjement',
            'Kandidat-database',
          ],
          unitType: '/måned',
        },
        'recright-video-interview': {
          features: [
            'Recright ATS er inkludert',
            'Innspilte videointervjuer',
            'Flere video-spørsmål',
            'Raporteringsverktøy',
            'Nett-trening',
            '15 videointervju-stillinger per år',
          ],
          unitType: '/måned',
        },
        'recright-custom': {
          features: [
            'Volumbaserte priser',
            'Dedikert account manager',
            'Integrasjon til din ATS',
            'Live videointervju',
          ],
          unitType: '/måned',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/måned',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/måned',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/måned',
        },
        'single-recruitment': {
          info: 'Perfekt for å prøve hele kraften av forhåndsinnspilte intervjuer.',
          features: [
            'Alle funksjoner er inkludert',
            'Inkluderer en enkel jobbannonse og et videointervju',
            'gyldig i 60 dager, \n\n etter jobbannonsen eller videointervjuet er opprettet',
          ],
          unitType: '/rekruttering',
        },
      },
    },

    branding: {
      headerFont: 'Skrift i overskrift',
      bodyFont: 'Skrift i brødtekst',
      backgroundColor: 'Bakgrunnsfarge',
      textColor: 'Tekstfarge',
      brandColor: 'Merkefarge',
      buttonTextColor: 'Tekstfarge på knapp',
      headerTextColor: 'Tekstfarge i overskrift',
    },

    candidateCard: {
      noStatus: 'Ingen status satt',
      lastSeen: time => `sist sett ${time}.`,
      notVisited: 'Har ikke vært på intervju.',
    },

    comments: {
      placeholder: 'Legg til en ny kommentar',
      submit: 'Legg til',
      delete: 'Slette',
      showComments: 'Vis andres kommentarer',
      hideComments: 'Skjul andres kommentarer',
    },

    competencyList: {
      duplicateError: 'En kompetanse med det navnet finnes allerede',
      defaultText: 'Dersom du er usikker på hvilke kompetanser du skal bruke, har vi definert noen bra standarder du kan begynne med.',
      defaultLinkText: 'Få standardene',
      addCompetency: 'Legg til ny kompetanse',
    },

    chooseLicenseLink: {
      title: 'Choose license',
    },

    currentFilters: {
      currentFilters: 'Filtre i bruk:',
    },

    emailForm: {
      emailLabel: 'E-post',
      defaultButtonText: 'Send',
    },

    filterToggler: {
      hideFilters: 'Skjul filtre',
      showFilters: 'Vis filtre',
    },

    hashtags: {
      placeholder: 'Legg til en tagg',
      delete: 'Slette',
    },

    imageInput: {
      errors: {
        format: 'Filen er ikke et bilde.',
        size: 'Bildefilen er for stor, maksimal filstørrelse er 4 MB.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Emne',
      messagePlaceholder: 'Melding',
      namePlaceholder: 'Navn',
      namePlaceholder2:
        'Hvis det står tomt, bruker gjeldende brukersignatur eller navn når du sender invitasjoner.',
      templateNameLabel: 'Malnavn',
      titleDisclaimer:
        '[INTERVIEW TITLE] erstattes med intervjutittelen ved sending av invitasjonene.',
      titleDisclaimerJob: '[JOBBTITEL] erstattes av stillingstittelen.',
      confirmLanguageChange:
        'Er du sikker på at du ønsker å endre språket? Alle endringer som ikke er lagret går tapt.',
      formatInfo:
        'Du kan legge til tekst med fet skrift, kursiv tekst eller lenker med spesialformatering:',
      cursive: '_Kursiv_',
      bolded: '*Fet*',
      link: '[http://example.com|Lenketekst]',
      greetingLabel: 'Hilsen',
      greetingPlaceholder:
        'Hilsen som vises på slutten av meldingen før signaturen.',
      greetingPlaceholder2: defaultGreeting =>
        `Hvis den er tom, brukes standardhilsenen ${defaultGreeting} i den sendte meldingen.`,
      getDefaultGreeting: 'Hent standardhilsen',
    },

    liveEvaluation: {
      interviewTabLabel: 'Interview',
      evaluationTabLabel: 'Evaluation',
      interviewNotesLabel: 'Interview notes',
      evaluationNotesLabel: 'Evaluation notes',
      thankYouLabel: 'Thank you!',
      evaluationSavedLabel: 'We have saved your evaluation of the candidate.',
      evaluatorLabel: 'Evaluator',
      evaluatorCount: count => (count === 1 ? '1 has evaluated' : `${count} have evaluated`),
      interviewersLabel: 'Interviewers',
      transcriptLoadingLabel: 'Transcript loading',
      recordingLabel: 'Interview recording',
      evaluationNotesPlaceholder: stepTitle => `Notes for ${stepTitle}`,
      goToAILabel: 'Jump to AI notes',
      goBackLabel: 'Go back up',
      AISummaryLabel: 'AI Summary',
      AINotesLabel: 'AI Notes',
      AIInsightsLabel: 'AI Insights',
      aiAssistant: 'AI Assistant',
      average: 'Average',
      continueLaterLabel: 'Continue later',
      transcriptButtonText: 'Interview transcript',
      transcriptionError: 'Error fetching transcript',
      finishAndSubmitLabel: 'Finish the evaluation',
      averageForAllSections: 'Average for the interview',
      continueLaterText: title =>
        `We sent you an email with the link so you can continue the candidate evaluation in the interview ${title} later.`,
      continueLaterNoTitleText:
        'We sent you an email with the link so you can continue the candidate evaluation in the interview later.',
      closeEvaluation: 'Close',
      continueEvaluation: 'Continue evaluation',
      confirmationTitle: 'Finish the evaluation?',
      confirmationMessage:
        'Are you sure you want to finish the evaluation? You will not be able to make further changes after finishing.',
      previousStepButton: 'Go to previous',
      nextStepButton: 'Go to next',
      selectAtLeastOneEvaluator: 'Please select at least one evaluator.',
      interviewInsights: 'Interview insights',
    },

    interviewFormSetup: {
      title: 'Intervjuets skjemaoppsett',
      notAsked: 'Ikke spurt',
      optional: 'Valgfri',
      required: 'Nødvendig',
      name: 'Navn',
      email: 'E-post',
      phoneNumber: 'Telefonnummer',
      city: 'By',
      attachments: 'Vedlegg',
      links: 'Lenker',
      attachmentsDescription: 'Beskrivelse for vedlegg',
    },

    interviewRow: {
      invites: 'Invitasjoner',
      responses: 'Svar',
      endTime: 'Sluttdato',
      createdAt: 'Opprettelsesdato',
      timedTitle: 'Tidsbestemt intervju',
      newVideos: 'Nye svar',
    },

    interviewGuideRow: {
      createdAt: 'Creation date',
      owner: 'Owner',
      language: 'Language',
    },

    interviewRoundRow: {
      createdAt: 'Creation date',
      owner: 'Owner',
      language: 'Language',
      endTime: 'Open until',
      status: 'Status',
    },

    interviewGuideStep: {
      noSteps: 'No sections added yet',
      reorder: 'Reorder sections',
      titleLabel: 'Section title',
      titlePlaceholder: 'Add a title for the section',
      interviewContentPlaceholder: 'Content for the section during interview',
      evaluationContentPlaceholder: 'Content for the section after interview',
      interviewTabLabel: 'Questions',
      evaluationTabLabel: 'Evaluation',
      stepTimeLabel: 'Section time estimate (min)',
      stopReordering: 'Stop reordering sections',
      delete: 'Delete section',
      add: 'Add new section',
    },

    introduction: {
      batchIntroduction: count => `Introdusert til ${count} mottagere`,
    },

    jobAdRow: {
      newApplications: 'Usett',
      applications: 'Søknader',
      publishTime: 'Publiseringsdato',
      endTime: 'Åpen til',
    },

    positionStatus: {
      open: date => (date ? `inntil ${date}` : ''),
      hidden: date => (date ? `inntil ${date}` : ''),
      filled: () => 'status: Bemannet',
      cancelled: () => 'status: Avbrutt',
      closed: () => 'status: Lukket',
      draft: () => 'status: Lukket (utkast)',
      unpublished: () => 'status: Ikke publisert',
      publishTime: 'Publiseringsdato',
    },

    jobAdTeaser: {
      add: 'Lage ny søknad',
      noApplications: 'Ingen søknader ennå.',
      preview: 'Forhåndsvis jobbannonsen her',
      placeholder: {
        first: 'Du kan øke og markedsføre jobbannonsen med direktelinker på din jobbportal',
        second: 'eller du kan markedsføre denne bestemte jobben med en direktelink',
        third: 'Husk at alt dette kun er en knapp unna med tittelfanen ovenfor.',
      },
    },

    list: {
      total: count => `Total: ${count}`,
      selectAll: 'Velg alle',
      resetSelection: count => (count > 0 ? `Tilbakestill utvalg (${count})` : 'Tilbakestill utvalg'),
    },

    liveRow: {
      finished: 'Ferdig',
      coming: 'Planlagte',
      active: 'Pågående',
      startTime: 'Start time',
      interviewers: 'Interviewers',
      candidates: 'Candidates',
      status: 'Status',
      titleFallback: 'Live interview',
    },

    loginForm: {
      email: 'E-post',
      password: 'Passord',
      submit: 'Logg inn på tjenesten',
      changePasswordInfo:
        'Password changed successfully! Please Log in with your new password.',
      error: {
        email: {
          isRequired: 'Vennligst oppgi din e-postadresse.',
          isEmail: value => (value ? `${value} er ikke en gyldig e-postadresse.` : ''),
        },
        password: {
          isRequired: 'Vennligst oppgi et passord.',
        },
        login: {
          incorrect: 'Innlogging feilet.',
          deactivated:
            'Brukerkontoen er blitt deaktivert. Kontakt organisasjonens administrator hos Recright.',
          tries: 'For å beskytte din sikkerhet begrenser vi antall passordforsøk. Forsøk igjen eller tilbakestill passordet ditt.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Organisasjonslogo her',
      removeLogo: 'Fjern logo',
      addLogo: 'Velg logo',
    },

    modalAccountType: {
      title: 'Endre kontotype?',
      confirm: 'Endre',
      cancel: 'Avbryte',
    },

    modalApplicationAllInvited: {
      title: 'Invitere kandidater',
      description: 'Alle de valgte kandidaten har allerede blitt invitert til intervjuet.',
    },

    modalApplicationIntroduce: {
      title: 'Introdusere kandidater',
      description: 'Oppgi e-posten til mottakeren av introduksjonen nedenfor',
      titlePlaceholder: 'Tittel',
      contentPlaceholder: 'Meldingsinnhold',
      emailsPlaceholder: 'Mottakers e-poster',
      namePlaceholder: 'Navn',
      cancel: 'Avbryte',
      sendIntroductions: 'Send introduksjoner',
    },

    modalApplicationInvite: {
      title: 'Velge et videointervju',
      description: 'Ønsker du å lage et nytt videointervju eller benytte et eksisterende?',
      createNew: 'Lage nytt videointervju',
      videoInterviewDescription: 'Inviter en kandidat til et videointervju, og møt den virkelige personen bak CV-en!',
      error: {
        selectInterview: 'Velg intervju.',
      },
      cancel: 'Avbryte',
      close: 'Lukke',
      continue: 'Fortsette',
    },

    modalApplicationReInvite: {
      title: 'Resende invitasjonen til søker',
      description: 'Velg intervjuet du ønsker å invitere søkeren til på nytt.',
      info: 'Du kan ikke sende invitasjoner til intervjuer som er stengt.',
      submit: 'Send invitasjon på nytt',
      cancel: 'Avbryte',
    },

    modalApplicationMessage: {
      title: 'Send melding til valgte kandidater',
      description: 'Hvilken type melding ønsker du å sende?',
      email: 'Send e-post',
      videoMessage: 'Send videomelding',
      close: 'Lukke',
      cancel: 'Avbryte',
      continue: 'Fortsette',
      sendEmail: 'Send melding',
      emailTitle: 'Send e-post til kandidater',
      emailDescription: 'Skriv e-post til valgte kandidater',
      videoTitle: 'Legg til ny video',
      titlePlaceholder: 'Tittel',
      contentPlaceholder: 'Skriv meldingen din her',
      candidates: 'kandidater',
      selectedCandidates: 'Mottakere',
      emailSent: 'E-post sendt!',
      answerable: 'Videoen kan besvares',
      signature: 'Vennlig hilsen,',
    },

    modalAtsTeaser: {
      title: 'Publiser åpne stillinger og administrer rekrutteringsprosessen',
      content: 'Velg informasjonen du vil be om fra kandidatene og publisere dine åpne stillinger. Vi er vert for karrieresiden din og du kan enkelt dele linken hvor som helst. Ditt arbeidsgiver-image blir bedre med effektiv kandidat-kommunikasjon.',
      cancel: 'Avbryt',
      confirm: 'Ja, kontakt meg',
      greetings: 'Melding vellykket sendt.',
    },

    modalFeedbackPulseTeaser: {
      title: 'Nysgjerrig på hvordan kandidatene dine vurderte rekrutteringsprosessen?',
      content: 'Ved slutten av hver rekrutteringsprosess, har kandidatene muligheten til å vurdere hvordan de opplevde den. Din samlede vurderingen baseres på gjennomsnittet av alle de innsamlede tilbakemeldingene.',
      cancel: 'Avbryt',
      confirm: 'Ja, kontakt meg',
      greetings: 'Meldingen ble sendt.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Send melding til valgte kandidater' : 'Send en melding til kandidaten'),
      description: 'Hvilken type melding ønsker du å sende?',
      recipients: count => `Melding vil bli sendt til ${count} mottakere`,
      email: 'Send e-post',
      videoMessage: 'Send videomelding',
      library: 'Velg fra bibliotek',
      close: 'Lukke',
      cancel: 'Avbryte',
      continue: 'Fortsette',
      sendEmail: 'Send melding',
      resendInvitation: 'Send invitasjon på nytt',
      resendInvitationSms: 'Send invitasjon på nytt med SMS',
      sms: 'Send melding på SMS',
      emailTitle: count => (count > 1 ? 'Send e-post til kandidater' : 'Send en e-post til kandidaten'),
      emailDescription: 'Skriv e-post til valgte kandidater',
      videoTitle: 'Legg til ny video',
      libraryTitle: count => (count > 1 ? 'Send video til kandidater' : 'Send en video til kandidaten'),
      titlePlaceholder: 'Tittel',
      contentPlaceholder: 'Skriv meldingen din her',
      candidates: 'kandidater',
      selectedCandidates: 'Mottakere',
      emailSent: candidates => `${candidates} e-poster sendt!`,
      answerable: 'Videoen kan besvares',
      successMessage: candidates => `${candidates} videoer sendt!`,
      scheduledInterview: 'Send invitasjon til planlagt intervju',
      reScheduledInterview: 'Endre møtetidspunkt',
      record: 'Ta opp',
      upload: 'Last opp',
      scheduledInterviewDescription: 'La kandidaten planlegge et møte med deg, basert på din oppførte tilgjengelighet.',
      reScheduledInterviewDescription: 'Flytt et planlagt møte med en kandidat. Merk at tidligere møteinvitasjoner kanselleres',
      required: '* Feltene merket med stjerne er obligatoriske.',
      tooManyRecipients: count => `For mange mottakere valgt. Maksimum er ${count}.`,
      tooLongMessage:
        'Meldingen er for lang. Kontroller tegntelleren. Merk: Noen spesialtegn reduserer den maksimale lengden på meldingen.',
    },

    modalEditIntroduceBatches: {
      title: 'Introduksjoner',
      description: 'Her kan du administrere stillingens introduksjoner. Du kan forlenge utløpsdatoen for introduksjonsmottakerens introduksjonskobling, fjerne mottakere fra introduksjonsgruppen eller fjerne hele introduksjonsgrupper fra stillingen.',
      noBatches: 'Ingen introduksjoner.',
      descriptionWithCount: (candidateNames) => `Introduserte ${candidateNames} og %COUNT_LINK% andre til følgende mottakere:`,
      descriptionWithoutCount: candidateNames => `Introduserte ${candidateNames} til følgende mottakere:`,
      expires: 'Utløper',
      visited: 'Besøkt',
      email: 'E-post',
      actions: 'Handlinger',
      close: 'Lukke',
      extendLinkText: 'Forlenge',
      extendTo: date => `Forlenge til ${date}`,
      deleteBatch: 'Slett introduksjonsgruppe',
      deleteBatchWarning: 'Er du sikker på at du ønsker å slette introduksjonsgruppen?',
      maxExpirationDate: 'Utløpsdatoen kan være maksimalt 10 dager fra dagens dato.',
      extendedMessage: newExpirationDate => `Utløpsdato for mottagerens introduksjonskobling forlenget til ${newExpirationDate}!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Informasjon om avsender av invitasjonsmelding',
      customReplyToSubtitle:
        'Her kan du redigere avsendernavn og svaradresse for intervjuinvitasjonene. Hvis den er tom, brukes navnet og e-postadressen til brukeren som sender invitasjonene.',
      customReplyToEmail: 'E-postsvar for intervjuinvitasjoner',
      customReplyToName: 'Avsendernavn for intervjuinvitasjoner',
      saveSuccess: 'Endringene ble lagret.',
    },

    modalEditInvitationMessage: {
      saveTemplate: 'Lagre som invitasjonsmeldingen for dette intervjuet',
      title: 'Rediger intervjuets invitasjonsmelding',
      info: 'Velg intervjuet du ønsker å redigere',
      close: 'Lukke',
      templateSaved: 'Meldingen ble nå lagret som mal for dette intervjuet.',
      templateOptionsLabel: 'Select template',
      interviewRound: {
        title: 'Edit the invitation message for this interview round',
        submitButtonText: 'Save interview round invitation template',
        templateSaved: 'The interview round invitation template was saved',
      },
    },

    modalEditStages: {
      title: 'Rediger rekrutteringsnivåer',
      info: 'Du kan redigere, legge til, slette og omorganisere tilpassede nivåer. Legg merke til at det ikke er mulig å fjerne et nivå hvis det er kandidater på det nivået.',
      addNewStage: 'Legg til et nytt tilpasset nivå',
      removeDisabled: 'Det er ikke mulig å slette et nivå som inneholder kandidater.',
      error: 'Nivået eksisterer allerede.',
      done: 'Ferdig',
      save: 'Lagre',
      close: 'Lukke',
      confirm: 'Bekrefte',
      cancel: 'Avbestillings',
      delete: 'Slette',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Skjulte stillinger',
      modalDescription: name => `Kontroller hvilke stillinger brukeren ${name} får se.`,
      hiddenFrom: name => `Stillinger skjult for brukeren ${name}`,
      noResults: 'Ingen resultater',
      jobAdLabel: 'Stillingsannonse',
      interviewLabel: 'Videointervju',
      noPositions: 'Ingen stillinger',
      close: 'Lukke',
      remove: 'Fjerne',
      hide: 'Skjul',
      searchInfo: 'Bla i stillinger som kan skjules',
      searchPlaceholder: 'Søk etter stillingens tittel eller plassering',
      total: total => `Totalt ${total} stillinger`,
      labels: {
        title: 'Tittel',
        location: 'Plassering',
        time: 'Opprettelsesdato',
        actions: 'Handlinger',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Fjern brukeren fra denne organisasjonen',
      modalDescription: name =>
        `Brukeren ${name} er en ekstern bruker og fjernes bare fra denne organisasjonen. Til tross for denne fjerningen, beholder de tilgangen til andre organisasjoner i Recright.`,
      modalExplanation: name =>
        `Følgelig har ikke brukeren lenger tilgang til stillinger i denne organisasjonen. Du arver tilgang til stillinger som ${name} var den eneste rekruttereren for.`,
      adminInRecruitmentTeam: name =>
        `Stillinger der brukeren ${name} var en del av rekrutteringsteamet:`,
      noResults: 'Ingen resultater',
      noPositions: 'Ingen stillinger',
      jobAdLabel: 'Stillingsannonse',
      interviewLabel: 'Videointervju',
      total: total => `Totalt ${total} stillinger`,
      close: 'Lukke',
      remove: 'Fjern fra organisasjonen',
      removeUserConfirmMessage: 'Fjern bruker',
      removeUserConfirmContent:
        'Er du sikker på at du vil fjerne brukeren fra denne organisasjonen?',
      labels: {
        title: 'Tittel',
        time: 'Opprettelsesdato',
        creator: 'Ny innehaver av stilling',
      },
      otherAdmin: 'Annen administrator i rekrutteringsteamet',
    },

    modalInterviewRoundSelectInviteType: {
      title: 'Select scheduling type',
      subtitle: 'Choose if you want to select the time for the interview yourself or if you want to let the candidate select the time.',
      regularTitle: 'Regular',
      regularDescription: 'The time of the interview is chosen by you.',
      scheduledTitle: 'Scheduled',
      scheduledDescription:
        "The time of the live interview is chosen by the candidate based on the interviewers' availability.",
      cancel: 'Avbryt',
      continue: 'Fortsett',
    },

    modalInterviewRoundInvite: {
      nameEmailLabel: 'Name/Email',
      startTimeLabel: 'Interview start time',
      title: 'Schedule interview',
      submit: 'Invite candidates',
      selectedCandidates: 'Selected candidates',
      savedTemplate: 'Saved invitation message template',
      templateChangedInfo:
        'You have edited the invitation message. This change will be sent to this batch of recipients, but will not be saved to the interview round invitation template.',
      saveTemplate: "Save as interview round's invite template",
      templateSaved:
        'The message was now saved as a template for this interview round.',
    },

    interviewRoundInviteModalContent: {
      subjectPlaceholder: 'Emne',
      messagePlaceholder: 'Melding',
      namePlaceholder: 'Navn',
    },

    modalReschedule: {
      title: 'Endre møtetidspunkt',
      submit: 'Send ombokningsmeddelande',
      rescheduleConfirmBody: 'Er du sikker på at du vil endre tidspunktet for dette intervjuet?',
    },

    modalPersonStage: {
      new: 'Ny',
      hired: 'Bemannet',
      proceed: 'Fortsett',
      personalinterview: 'Personlig intervju',
      withdrawn: 'Trukket',
      scheduledinterview: 'Planlagt intervju',
      rejected: 'Avvist',
      videointerviewed: 'Videointervju',
      change: 'Flytt kandidaten(e) til et annet nivå',
      info: 'Flytt den/de valgte kandidaten(e) til et annet nivå. Denne opplysningen er ikke synlig for kandidatene.',
      changedInfo: stage => `Nå som du har flyttet disse kandidatene til nivået "${stage}” kan du la dem få vite det! \n\n Send dem en e-post eller en videomelding.`,
      done: 'Flytt',
      cancel: 'Avbryte',
      changed: 'Flott!',
      close: 'Lukke',
      reopenProcessConfirmPlural: 'Er du sikker på at du ønsker å flytte disse kandidatene vekk fra stadiet "Trukket", og tilbake til rekrutteringsprosessen? Etter at dette er bekreftet, vil kandidatene igjen kunne svare på ethvert intervju som ikke har blitt fullført enda.',
      withdrawConfirmPlural: 'Er du sikker på at du ønsker å trekke disse kandidatene fra rekrutteringsprosessen? Dersom de blir trukket, vil kandidatene ikke lenger kunne svare på intervjuer de var invitert til.',
      changeSingle: 'Flytt kandidaten til et annet trinn',
      infoSingle: 'Flytt kandidaten til et annet trinn. Denne informasjonen er ikke synlig for kandidaten.',
      changedInfoSingle: stage => `Nå som du har flyttet kandidaten til trinnet "${stage}", bør du fortelle om det! \n\n Send en e-post eller videomelding.`,
    },

    modalInterviewAdd: {
      timedTitle: 'Tidsbestemt intervju',
      timedDescription: 'Kandidater spiller inn svarene sine på intervjuspørsmålene, innenfor en begrenset og forhåndsbestemt tidsramme. Du kan angi tiden som er tilgjengelig for både svar og forberedelse, for hvert spørsmål.',
      title: 'Opprett nytt intervju',
      description: 'Velg typen intervju du ønsker å opprette',
      friendlyTitle: 'Videointervju',
      friendlyDescription: 'Kandidatene kan gjøre så mange innspillingsforsøk de ønsker, og det finnes ingen tidsbegrensning for hvert forsøk.',
      cancel: 'Avbryt',
      continue: 'Fortsett',
    },

    modalLiveInterviewAdd: {
      title: 'Create new live interview',
      description: 'Choose the type of live interview you want to create.',
      basicTitle: 'Normal live interview',
      basicDescription: 'The time of the live interview is chosen by you.',
      scheduledTitle: 'Scheduled live interview',
      scheduledDescription:
        'The time of the live interview is chosen by the candidate based on your availability.',
      cancel: 'Avbryt',
      continue: 'Fortsett',
    },

    modalInterviewPublish: {
      modalTitle: 'Publiseringsinnstillinger',
      publicTitle: 'Offentlig intervju',
      publicDescription: 'Dette intervjuet har en offentlig side med en adresse du kan dele i stillingsannonsen og på bedriftens nettside. Alle som er interesserte i stillingen kan se spørsmålene dine og bestemme seg for å delta. Du mottar den vanlige varslingen når svarene begynner å komme.',
      publishButton: 'Lage offentlig link',
      unPublishButton: 'Fjerne offentlig link',
      title: 'Innebygget intervju',
      description: 'Intervjuer med et spørsmål kan sømløst integreres på selskapets hjemmeside. Kandidaten legger inn sin e-postadresse, spiller inn en video-respons og oppgir frivillig sin Linkedin-profil eller annen informasjon gjennom en link.',
      descriptionMultiple:
        'Integrer et videointervju sømløst i jobbannonsen eller på bedriftens hjemmeside. Kandidatene legger bare inn e-postadressen sin, spiller inn videosvar og har mulighet til å legge inn en lenke til LinkedIn-profilen sin for ytterligere informasjon.',
      embedNotification: 'Du kan ikke be om andre opplysninger med et intervju som er innebygd i nettstedet.',
      embedButton: 'Lag innebygget kode',
      unEmbedButton: 'Fjerne innebygget',
      close: 'Lukke',
      oneError: 'Et innebygd intervjuet kan inneholde bare ett spørsmål. Slett de andre spørsmålene for å kunne bruke innebygd intervju.',
      subscriptionNeeded: 'Du trenger et aktivt abonnement for å publisere intervjuet ditt.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Introdusere kandidater' : 'Introduser kandidaten'),
      descriptionFirst: 'Introduksjonsfunksjonen lar deg presentere utvalgte kandidater til kollegaer eller kunder.',
      descriptionSecond: 'Det er ikke nødvendig at introduksjonsmottaker registrerer seg for å se de introduserte kandidatene. Skriv inn introduksjonsmottakeres e-postadresser nedenfor. Velg hvilken informasjon du ønsker at mottakere skal se om kandidaten. Mottakerne vil kun se den valgte informasjonen. Hvis du velger "Vurdering" eller "Kompetanse og kompatibilitet" vil mottakerne kunne angi sine vurderinger og vil også se den gjennomsnittlige vurderingen.',
      descriptionThird: 'Du har også muligheten til å beskytte introduksjonene med en tilgangskode som mottakere må oppgi for å se de introduserte kandidatene.',
      descriptionFourth: days =>
        `Introduksjonskoblingen utløper om ${days} dager. Du kan forlenge utløpsdatoen fra introduksjonsinnstillingene. Du finner disse innstillingene på "Rediger"-menyen, under "Rediger introduksjoner".`,
      titlePlaceholder: 'Tittel',
      contentPlaceholder: 'Meldingsinnhold',
      emailsPlaceholder: 'Mottakers e-poster',
      namePlaceholder: 'Navn',
      cancel: 'Avbryte',
      sendIntroductions: 'Send introduksjoner',
      selectedCandidates: count => `${count} kandidatene er valgt for innføring`,
      successMessage: (candidates, introducees) => `${candidates} kandidater introdusert til ${introducees} personer`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} kandidater introdusert til ${introducees} introduserte. ${isInTeam} var allerede på rekrutteringsteamet.`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'er allerede på rekrutteringsteamet.' : 'er allerede på rekrutteringsteamet.'),
      name: 'Navn',
      email: 'E-post',
      phone: 'Telefonnummer',
      city: 'By',
      coverLetter: 'Følgebrev',
      attachments: 'Vedlegg',
      links: 'Lenker',
      competencies: 'Kompetanse og kompatibilitet',
      rating: 'Rangering',
      videoResponses: 'Videosvar',
      comments: 'Kommentarer',
      informationsHeader: 'Velg hvilken informasjon som skal introduseres',
      messageHeader: 'Introduksjonsmelding',
      usePasscodeText: 'Beskytt introduksjonsgruppen med en tilgangskode',
      passcode: 'Tilgangskode',
      copyToClipboard: 'Kopier kode til utklippstavle',
      generatePasscode: 'Generer ny tilgangskode',
      selectAll: 'Velg alle',
      resetSelection: 'Tilbakestill utvalg',
      copySuccess: 'Passkode kopiert!',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      aiInsights: 'AI-innsikt',
      transcripts: 'Transkripsjoner',
      continue: 'Fortsette',
    },

    modalInterviewInvite: {
      senderInfo: 'Invitasjoner sendes fra invitations@recright.com e-postadresse.',
      replyToEmail: 'E-postsvar for intervjuinvitasjoner',
      replyToName: 'Avsendernavn for intervjuinvitasjoner',
      replyToInfo:
        'Du kan redigere disse feltene fra intervjuredigeringssiden.',
      notAnswerable: 'Du kan ikke invitere brukere til lukket intervju eller intervju som ikke har ansvarlig spørsmål.',
      title: 'Invitere kandidater',
      description: 'Oppgi alle kandidatenes e-postadresser. Du blir varslet på e-post når de svarer.',
      description2: 'Merk at når du har invitert kandidater kan du ikke lenger legge til spørsmål.',
      smsDescription: 'Etter å ha sendt invitasjoner på e-post, kan du sende en melding på SMS til kandidatene',
      addressesPlaceholder: 'Kandidatenes e-postadresser',
      submit: 'Send invitasjoner',
      cancel: 'Avbryte',
      close: 'Lukke',
      templateChangedInfo: 'Du har redigert invitasjonsmeldingen. Denne endringen sendes ut til denne bunten med mottakere, men lagres ikke til intervjuet.',
      templateSaved: 'Denne meldingen ble nå lagret som mal for intervjuet.',
      inviteInfo: (newInvitees, stage) => `Invitasjonsmeldingen vil bli sendt til ${newInvitees} kandidater fra de valgte kandidatene. Alle utvalgte kandidater vil bli flyttet til nivået "${stage}".`,
      invitesSent: (success, failed) => (failed > 0 ? `sendte ${success} invitasjoner og ${failed} allerede invitert.` : `sendte ${success} invitasjoner.`),
      subscriptionNeeded:
        'Du må ha et aktivt abonnement for å invitere kandidater.',
      saveTemplate: 'Lagre som invitasjonsmeldingen for dette intervjuet',
      rrTemplateOptionLabel: 'Gjenopprett standardmal',
      interviewTemplateOptionLabel:
        'Invitasjonsmelding lagret til dette intervjuet',
      interviewRoundTemplateOptionLabel: 'Invitasjonsmelding lagret til dette intervjurunde',
      templateOptionsLabel: 'Velg mal',
    },

    modalInterviewInviteSms: {
      title: 'Invitasjonene ble sendt',
      description: count => `${count} invitasjoner sendt`,
      description2: 'Ønsker du også å sende en melding på SMS til de inviterte kandidatene?',
    },

    modalSmsMessage: {
      description: count => `Melding vil bli sendt til ${count} mottakere`,
      phonePlaceholder: 'Telefonnummer',
      title: 'Send melding på SMS',
      invitationTitle: 'Send invitasjoner på SMS',
      resendInvitationTitle: 'Send invitasjon på nytt med SMS',
      missingInvitationDescription: count => `${count} mottakere mangler invitasjoner. Skriv invitasjonsmeldingen nedenfor.`,
      missingPhone: count => `${count} mottakere mangler et gyldig mobiltelefonnummer.`,
      missingPhone2: 'Legg til mobiltelefonnumrene i feltene nedenfor.',
      successMessage: count => `${count} Meldinger på SMS ble sendt.`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} Meldinger på SMS ble sendt. Kunne ikke levere ${failedCount} SMS-meldinger.`,
      failedMessage: 'Kunne ikke sende melding på SMS til noen av mottakerne',
      recipientsNotFound: 'En uventet feil oppsto. Prøv igjen senere, og hvis problemet vedvarer, ta kontakt med kundestøtte.',
    },

    modalInterviewStatus: {
      change: 'Endre intervjustatus',
      changed: 'Intervjustatus endret',
      changeRoundStatus: 'Change interview round status',
      roundStatusChanged: 'Interview round status changed',
      changedInfo: 'Intervjustatus endret. Husk å opplyse kandidatene når det velges!',
      info: 'Velg statusen til dette intervjuet.',
      open: 'Åpen',
      closed: 'Lukket',
      done: 'Ferdig',
      close: 'Lukke',
      endTimeInPast: model => model === 'interview' ?
        'Intervjuet har en sluttdato som er forbigått. Når du åpner intervjuet, vil sluttdatoen fjernes. Du kan angi en ny sluttdato fra ' :
        'This interview round has an end date that is in the past. When you open the interview round the end date will be removed. You can set a new end date from the ',
      endTimeInPastLink: 'redigeringssiden',
      cancel: 'Avbryt',
    },

    modalInterviewSelectForEdit: {
      title: 'Rediger opplysninger',
      info: 'Velg intervjuet du ønsker å redigere.',
      cancel: 'Avbryt',
      done: 'Ferdig',
      error: {
        selectInterview: 'Velg intervju.',
      },
    },

    modalJobAdPreview: {
      title: 'Forhåndsvisning av jobbannonse',
      description: 'Her ser du hvordan jobbannonsen vises for kandidaten.',
      description2: 'Merk at språket som brukes i forhåndsvisningen ikke er det samme som er angitt for jobbannonsen.',
      close: 'Lukke',
      back: 'Tilbake',
    },

    modalJobAdStatus: {
      change: 'Endre jobbstatus',
      changed: 'Jobbstatus endret',
      changedInfo: 'Jobbstatus endret. Husk å opplyse kandidatene når det velges!',
      info: 'Velg den nye statusen for denne jobbstillingen. Settes status til "bemannet" eller "avbrutt" blir du veiledet gjennom de nødvendige trinnene for å velge personen som skal ansettes, og/eller sende "beklager"-meldinger',
      open: 'Åpen',
      filled: 'Bemannet',
      cancelled: 'Avbrutt',
      done: 'Ferdig',
      close: 'Lukke',
      draft: 'Lukket (utkast)',
      closed: 'Lukket',
      unpublished: 'Ikke publisert',
      hidden: 'Skjult',
      openDescription: 'Jobbannonsen er publisert frem til',
      filledDescription: 'Lukke jobbannonsen fordi stillingen er bemannet.',
      cancelledDescription: 'Lukke jobbannonsen fordi rekrutteringsprosessen er avbrutt.',
      closedDescription: 'Jobbannonsen er lukket. Jobbannonsen er ikke tilgjengelig eller synlig for kandidatene.',
      hiddenDescription: 'Skjul stillingen fra bemanningssiden. Stillingen er kun tilgjengelig med en direktelink:',
      unpublishedDescription: 'Stillingsannonsen har ikke blitt publisert. Jobbannonsen er ikke tilgjengelig eller synlig for kandidatene.',
      cancel: 'Avbryte',
    },

    modalJobPositionTeam: {
      addAnother: 'Legg til flere brukere ved å sende inn inn e-postadressene deres',
      team: 'Rekrutteringsteam',
      info: 'Du kan legge til kollegaer eller andre brukere for gjennomgang og evaluering av kandidater',
      newMembersMsg: 'Nye teammedlemmer uten eksisterende konto i Recright legges til organisasjonen der denne stillingen tilhører.* Hvis brukerens e-postdomene ikke samsvarer med domenet som er knyttet til organisasjonen, får brukeren kun minimale brukertillatelser. Brukertillatelsene kan endres senere av administratorer som har tilgang til brukeradministrasjonen.',
      asteriskSymbol: '*',
      currentTeam: 'Nåværende team',
      done: 'Ferdig',
      remove: 'Fjerne',
      submit: 'Legg til teammedlemmer',
      cancel: 'Avbryte',
      selfRemovedMessage: 'Du har fjernet deg selv fra rekrutteringsteamet.',
      successMessage: count => `${count} medlemmer lagt til i rekrutteringsteamet.`,
      errors: {
        duplicate: 'E-post er allerede lagt til.',
        duplicateMultiple: 'Teammedlem(mer) er allerede funnet med én eller flere av e-postadressene som ble sendt inn.',
        isEmail: 'E-postadressen er ugyldig.',
        isEmailMultiple: 'Ugyldige e-postadresser ble funnet.',
        isRequired: 'Feltet er obligatorisk.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `Er du sikker på at du ønsker en kopi av ${context === 'jobAd' ? 'jobbstillingen' : 'intervjuet'} "${position.title}"?`,
      admins: 'Ønsker du også å kopiere rekrutteringsteamet?',
      done: 'Kopier',
      cancel: 'Avbryte',
    },

    modalVideos: {
      title: 'Videobibliotek',
      yourVideos: 'Dine videoer',
      companyVideos: 'Selskapets videoer',
      add: 'Legg til',
      done: 'Legg til videoer',
      cancel: 'Avbryte',
      selectedVideos: 'Valgte videoer',
      clearAll: 'Fjern alle',
    },

    videoCollectionBrowser: {
      allVideos: 'Alle videoer',
      noCollections: 'Ingen samling',
      videoCountSingular: 'video',
      videoCountPlural: 'videoer',
      folderView: 'Mappevisning',
      listView: 'Listevisning',
      sort: {
        createdAt: 'Opprettelsesdato',
        title: 'Tittel',
      },
    },

    modalUsersAdd: {
      title: 'Inviter brukere',
      languageDescription: 'Disse brukerne vil ha følgende språk:',
      permissionsDescription: 'Disse brukerne vil ha følgende tillatelser:',
      emailsPlaceholder: 'Skriv inn brukerens e-postadresser',
      seeAllPositions: 'Se alle stillinger',
      createJobPositions: 'Opprett arbeidsstilling',
      createInterviews: 'Opprett intervjuer',
      account: 'Rediger firmainformasjon',
      billing: 'Fakturering',
      reporting: 'Rapportering',
      editUsers: 'Rediger brukere',
      default: 'Firmaets standardtillatelser',
      cancel: 'Avbryt',
      submit: 'Inviter brukere',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Firmaets standardtillatelser:',
      description: 'Alle nye brukere som registrerer seg i dette firmaet vil automatisk få standardtillatelsene.',
      seeAllPositions: 'Se alle stillinger',
      createJobPositions: 'Opprett arbeidsstilling',
      createInterviews: 'Opprett intervjuer',
      account: 'Rediger firmainformasjon',
      billing: 'Fakturering',
      reporting: 'Rapportering',
      editUsers: 'Rediger brukere',
      cancel: 'Avbryt',
      submit: 'Lagre',
    },

    modalOtherApplications: {
      title: 'Kandidat i andre stillinger',
      header: 'Her er en liste over den samme kandidaten i andre stillinger',
      close: 'Lukke',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Se alle stillinger',
        createJobPositions: 'Opprett arbeidsstilling',
        createInterviews: 'Opprett intervjuer',
        account: 'Rediger firmainformasjon',
        billing: 'Fakturering',
        reporting: 'Rapportering',
        editUsers: 'Rediger brukere',
        default: 'Standardtillatelser',
      },
    },

    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelectedRegular: 'Select at least one interviewer',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnected:
          "The user's calendar is not connected to Recright, and their availability information cannot be accessed.",
        interviewerCalendarNotConnected2:
          "They'll receive an email with scheduling information and instructions on how to connect their calendar to Recright.",        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: 'Endre møtetidspunkt',
        confirmRescheduleContent: 'Noen mottakere har allerede et planlagt møte. Ønsker du å sende ut nye invitasjoner? Dette vil overskrive det tidligere planlagte møtet.',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      save: 'Lagre',
      cancel: 'Avbryt',
      addToCollection: 'Legg til i samling',
      title: 'Rediger video',
      success: 'Endringer i videoen er vellykket lagret!',
      error:
        'Vi klarte ikke å lagre endringene. Forsøk igjen senere, og kontakt vår kundestøtte dersom problemet vedvarer.',
    },

    noResults: {
      description: 'Listen ser ut til å være tom. Hvis du filtrerer listen må du prøve å redusere noen filtre.',
    },

    notifications: {
      notifications: 'Varslinger',
    },

    notificationsSubscribeButton: {
      subscribe: 'Abonner',
      subscribed: 'Abonnerer',
      unsubscribe: 'Avmeld',
    },

    onboardTutorial: {
      ui: {
        back: 'Tilbake',
        close: 'Lukk',
        last: 'Siste',
        next: 'Neste',
        skip: 'Slå av',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First thing first. Let\'s connect your calendar, so you can schedule meetings with candidates! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Velkommen til Recright!',
          text: 'Vi vil guide deg gjennom verktøyet med interaktive guider. Du kan se hjelpe-teksten om hver funksjon ved å klikke på pulsen. Guider kan gjøres synlig igjen når som helst ved å klikke på navnet ditt og "Vis opplæring".',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Opprett en ny jobbannonse',
          text: 'Opprett og publiser en ny stilling og motta søknader her.',
          selector: '.joyride--add-job-ad',
          position: 'top',
        },
        {
          title: 'Lag et nytt video-intervju',
          text: 'Lag et nytt videointervju og inviter kandidater her.',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: 'Innstillinger',
          text: 'Endre innstillingene på din konto, velg utseende på din karriereside og URL, administrer ditt video-bibliotek og velger foretrukket språk her. Du kan også slå på denne puls-guiden ved å klikke "Vis opplæring".',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Legg til hovedbanner og logo',
          text: 'Du kan legge til et hovedbanner til jobbannonsen og gjøre den synlig for kandidatene dine. Optimal bildestørrelse er 1440 x 320 piksler. Husk å legge til logoen din også.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Tittel, beliggenhet, publisere datoer',
          text: 'Skriv inn tittel, beliggenhet, sett publiseringsdato og frist. Hvis "Åpen til" etterlates blank, så er posisjonen åpen.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Jobb-beskrivelse',
          text: 'Skriv eller lim inn i jobb-beskrivelsen din her. Husk å nevne hva du leter etter, hva som er kravene og hva du har å tilby.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Arbeidsgiver-video',
          text: 'Du kan markedsføre din bedriftskultur og forbedre arbeidsgivers merkevarebygging ved å legge til en arbeidsgiver-video til jobbannonsen.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Søknadsskjema oppsett',
          text: 'Velg hva slags informasjon du ønsker å få fra dine kandidater. Feltene kan være valgfrie eller obligatoriske å svare på.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Video-spørsmål',
          text: 'Du kan spørre et bestemt video-spørsmål fra kandidater som allerede er i søknadsfasen og bringe søknader til live gjennom video-svar. Dette er også en flott mulighet for å si hei til dine kandidater.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Legg til hovedbanner og logo',
          text: 'Du kan legge til et hovedbanner til intervjuet og gjøre den synlig for kandidatene dine. Optimal bildestørrelse er 1440 x 320 piksler. Husk å legge til logoen din også.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Tittel, åpen til',
          text: 'Skriv inn tittel for video-intervjuet ditt og sett en svarfrist. Hvis du etterlater "Åpen til" blank, så er posisjonen åpen.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Intervjuskjema oppsett',
          text: 'Velg hvilken informasjon du ønsker å få fra dine kandidater. Feltene kan være valgfrie eller obligatoriske å svare på.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Intervjuspørsmål',
          text: 'Post eller last opp dine video-spørsmål. Du kan lagre video-spørsmål til biblioteket etter at du har laget dem og bruke dem på nytt senere. Du kan også bruke tekst-spørsmål hvis du ikke har muligheten til å bruke video-spørsmål. Kandidater svarer alltid med video.',
          selector: '.joyride--interview-video-questions',
          position: 'bottom-right',
        },
      ],
      createdJobAd: [
        {
          title: 'Jobbstillinger handlinger',
          text: 'Her kan du redigere stillingen, endre status og invitere teamet ditt til å evaluere kandidatene.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Promotere en stilling',
          text: 'Promoter stillingsannonsen din ved å dele den på sosiale medier.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Video-intervju handlinger',
          text: 'Her kan du redigere videointervjuet, endre status og invitere teamet ditt til å evaluere kandidatene.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Innstillinger for invitering og publisering',
          text: 'Inviter kandidater eller offentliggjør videointervjuet ditt. Deretter kan du promotere det og dele det på sosiale medier.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Kommentarer og klassifikasjoner',
          text: 'Du kan kommentere kandidatene, klassifisere dem med merkelapper og rangere dem med stjerner. Husk å sette en passende status for kandidaten, slik at teamet ser din beslutning. Kandidater ser ikke denne informasjonen.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Organisasjonsprofil',
      branding: 'Merking',
      stages: 'Stadier',
      emailTemplates: 'E-postmaler',
      evaluationScales: 'Vurderingsskalaer',
      competencies: 'Kompetanser',
    },

    passcode: {
      passcode: 'Tilgangskode',
      showPasscode: 'Vis passkode',
      hidePasscode: 'Skjul passkode',
    },

    passwordIndicator: {
      errors: [
        'Passordet må ha minst 12 tegn.',
        'Passordet må ha mindre enn 128 tegn.',
        'Passordet kan ikke bestå av deler på tre eller flere gjentatte tegn.',
        'Passordet må inneholde minst én liten bokstav: a-z',
        'Passordet må inneholde minst én stor bokstav: A-Z',
        'Passordet må inneholde minst ett tall: 0-9',
        'Passordet må inneholde minst ett spesialtegn: (f.eks. !, #, &)',
      ],
      strengthLabel: 'Passordstyrke: ',
      strengthValue: {
        insufficient: 'Utilstrekkelig',
        weak: 'Svakt',
        medium: 'Middels',
        strong: 'Sterkt',
      },
      learnMore: 'Lær hvordan du lager et sterkt passord',
    },

    personDetails: {
      namePlaceholder: 'Kandidat',
      links: 'Lenker',
      attachments: 'Vedlegg',
      referrer: 'Opphav',
      referrerInfo: 'Nettstedet som kandidat kom fra til tjenesten.',
      coverLetter: 'Følgebrev',
      lastSeen: time => `Sist sett ${time}.`,
      headerAdditionalInformation: 'Tilleggsinformasjon',
      state: {
        invited: 'Invitert',
        visited: 'Besøkt',
        incomplete: 'Ikke fullført',
        completed: 'Fullført',
      },
      liveCandidateState: {
        scheduling: 'Interview time selection',
        notInvited: 'No invitation sent',
        invited: 'Invited',
        interviewed: 'Interviewed',
        evaluated: 'Evaluated',
      },
      notVisited: 'Har ikke vært på intervju.',
      otherPersons: count => `Også funnet i ${count} andre stillinger`,
      name: 'Navn',
      email: 'E-post',
      phone: 'Telefonnummer',
      city: 'By',
      deadline: date => `Frist: ${date}`,
      deadlineExpired: 'Fristen har passert',
    },

    personEdit: {
      header: 'Rediger kandidatinformasjon',
      description: context => `Du kan redigere all grunnleggende kandidatinformasjon som er synlig for kandidatene på ${context === 'application' ? 'søknads' : 'intervju'} skjemaet.`,
      name: 'Kandidatens navn',
      email: 'Kandidatens e-post',
      phone: 'Kandidatens telefonnummer',
      city: 'Kandidatens nåværende hjemsted',
      link: 'Oppgi link',
      links: 'Legg til linker for eksempel til LinkedIn-profil',
      coverLetter: 'Følgebrev',
      attachments: 'Vedlegg',
      save: 'Lagre',
      cancel: 'Avbryt',
      editDetails: 'Rediger informasjon',
      editSuccess: 'Kandidatinformasjon lagret!',
    },

    personRow: {
      noStage: 'ikke i noe nivå foreløpig',
      lastSeen: time => `sist sett ${time}.`,
      notVisited: 'Har ikke vært på intervju.',
      selectPerson: 'Velg',
      deselectPerson: 'Fjern utvalg',
      openPersonPage: 'Åpne',
      interviewStartTime: 'Intervju starttidspunkt',
      noStartTimeSelected: 'Ingen starttid valgt',
      icons: {
        messages: messagesSent => `${messagesSent} meldinger sendt`,
        message: messagesSent => `${messagesSent} melding sendt`,
        noMessages: 'Ingen meldinger sendt',
        introduction: introductions => `${introductions} introduksjon`,
        introductions: introductions => `${introductions} introduksjoner`,
        noIntroductions: 'Ingen introduksjoner',
        comment: comments => `${comments} kommentar`,
        comments: comments => `${comments} kommentarer`,
        noComments: 'Ingen kommentarer',
        appliedWithLinkedIn: 'Anvendt med LinkedIn',
      },
      state: {
        invited: 'Invitert',
        visited: 'Besøkt',
        incomplete: 'Ikke fullført',
        completed: 'Fullført',
        scheduling: 'Interview time selection',
        notInvited: 'No invitation sent',
        interviewed: 'Interviewed',
        evaluated: 'Evaluated',
      },
      deadline: date => `Frist: ${date}`,
      deadlineExpired: 'Fristen har passert',
    },

    pipeline: {
      editInterview: 'Rediger opplysninger',
      titleLabel: 'Tittel',
      endTimeLabel: 'Åpen til',
      statusLabel: 'Status',
      locationLabel: 'Sted',
      editStages: 'Rediger nivåer',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: 'Hold oversikt over kandidatene dine gjennom ansettelsesprosessen. Flytt kandidater mellom de ulike stadiene i rekrutteringsforløpet. Du kan filtrere søknader etter stadier og andre kriterier.',
    },

    positionListing: {
      type: 'Type',
      title: 'Tittel',
      owner: 'Eier',
      count: 'Antall',
      invited: 'Invitert',
      visited: 'Besøkt',
      answered: 'Besvart',
      hired: 'Ansatt',
      leadTime: 'Ledetid',
      leadTimeValue: v => `${v} dager`,
      created: 'Opprettelsesdato (GMT)',
      start: 'Publiseringsdato (GMT)',
      end: 'Sluttdato (GMT)',
      jobAdLabel: 'Stillingsannonse',
      interviewLabel: 'Videointervju',
      timedLabel: 'Tidsbestemt intervju',
      embedLabel: 'Innebygget intervju',
      publicLabel: 'Offentlig intervju',
      timezone: 'Timezone',
      feedback: 'Tilbakemeldingsstatistikk',
    },

    qrCodeDownload: {
      download: 'Last ned QR-kode',
    },

    recentPositionsContainer: {
      createNew: 'Opprett ny',
      showAll: 'Vis alt',
    },

    recentJobAds: {
      openJobPositions: 'Åpne jobbstillinger',
      showAllJobPositions: 'Vis alle jobbstillinger',
      createNewJobPosition: 'Lage ny jobbstilling',
      subscriptionNeeded: 'Du trenger et aktivt abonnement for å publisere intervjuet ditt.',
      confirmSingleHire: 'One of your purchased single hires are used for this position.',
      newApplications: 'Usett',
      responses: 'Søknader',
    },

    recentInterviews: {
      openVideoInterviews: 'Åpne videointervjuer',
      showAllVideoInterviews: 'Vise alle videointervjuer',
      createNewVideoInterview: 'Lage nytt videointervju',
      invites: 'Invitasjoner',
      responses: 'Svar',
      timedTitle: 'Tidsbestemt intervju',
    },

    registrationForm: {
      email: 'E-post',
      submit: 'Logg inn på tjenesten',
      password: 'Passord',
      confirmPassword: 'Passord igjen',
      agreeTos: 'Jeg har lest og godtar ',
      agreeTosLinkText: 'Recrights vilkår og betingelser for bruk.',
      privacyPolicy: 'Jeg har gjort meg kjent med.',
      privacyPolicyLinkText: 'Personvernerklæringen.',
      licenseAgreement: 'På vegne av organisasjonen, godtar jeg ',
      licenseAgreementLinkText: 'Recrights generelle tjenestevilkår.',
      newsletter: 'Abonner på månedlig nyhetsbrev.',
      name: 'Navn',
      namePlaceholder: 'Fornavn Etternavn',
      organization: 'Organisasjon',
      companyDomain: domain => `Tillat brukere som registrerer seg med ${domain}-domenet å bli lagt til i til dette selskapet.`,
      error: {
        password: {
          isRequired: 'Passord er nødvendig. ',
          isValidPassword: 'Et gyldig passord må ha minst 12 tegn og inneholde minst én stor bokstav, én liten bokstav og ett tall.',
          passwordsMatch: 'Passord matcher ikke.',
        },
      },
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Kontakt faktureringsansvarlig i organisasjonen din.',
    },

    search: {
      placeholder: 'Søk',
    },

    searchFilter: {
      filter: 'Filter',
      headings: {
        location: 'Sted',
        state: 'Fremdrift',
        status: 'Status',
        tags: 'Tags',
        rating: 'Rangering',
        stage: 'Nivå',
      },
      state: {
        invited: 'Invitert',
        visited: 'Besøkt',
        incomplete: 'Ikke fullført',
        completed: 'Fullført',
        scheduling: 'Interview time selection',
        notInvited: 'No invitation sent',
        interviewed: 'Interviewed',
        evaluated: 'Evaluated',
      },
      status: {
        open: 'Åpen',
        filled: 'Bemannet',
        cancelled: 'Avbrutt',
        closed: 'Lukket',
        draft: 'Utkast',
        unpublished: 'Ikke publisert',
        hidden: 'Skjult',
        hired: 'Ansatt',
        new: 'Ny',
        all: 'Alle',
        proceed: 'Fortsett',
        videointerviewed: 'Videointervju',
        personalinterview: 'Personlig intervju',
        withdrawn: 'Trukket',
        scheduledinterview: 'Planlagt intervju',
        rejected: 'Avvist',
        finished: 'Ferdig',
        coming: 'Planlagte',
        active: 'Pågående',
      },
    },

    selectListings: {
      title: 'Oppføringer',
      description: 'Velg oppføringer hvor stillingen er publisert.',
    },

    session: {
      account: 'Kontostyring',
      language: 'Språk',
      logout: 'Logg ut',
      whatsNew: 'What\'s New',
      trainingMaterial: 'Recright-opplæring',
      expired: 'Vennligst logg inn igjen.',
      showTutorial: 'Vis opplæring',
      helpCenter: 'Recright Help Center',
      organization: 'Organisasjon',
    },

    showFeedbackPulse: {
      showPulse: 'Vis tilbakemelding',
      positive: avg => `${avg}% positive`,
      feedbackStatistics: 'Tilbakemeldingsstatistikk',
      noFeedback: 'Ingen tilbakemelding enda',
      responses: responses => `${responses} Svar`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `Du har ${count} enkeltleier igjen på kontoen din.`,
      notificationBody: 'Ved å invitere kandidater eller publisere intervjuet, vil én leie bli brukt.',
    },

    singleHires: {
      currentCount: count => `${count} enkeltleier tilgjengelig.`,
      purchase: 'Kjøp en enkeltleie',
      label: 'Enkeltleie',
      confirmMessage: amount => `Bekreft ditt enkeltstående kjøp. ${amount} EUR vil belastes kredittkortet ditt.`,
    },

    smartrecruitersPublish: {
      title: 'Smartrecruiters-integrering',
      description: 'Du kan legge til og fjerne individuelle intervjuer fra Videointervju-listen i Smartrecruiters.',
      notification: 'Merk at det kan ta opptil 24 timer før intervjuet vises i Smartrecruiters.',
      addButton: 'Legg til i Smartrecruiters',
      removeButton: 'Fjern fra Smartrecruiters',
      confirmRemove: 'Er du sikker på at du ønsker å fjerne intervjuet fra Smartrecruiters?',
      addConflict: 'Intervjuet har allerede blitt lagt til i Videointervju-listen',
      removeConflict: 'Intervjuet er allerede fjernet fra Videointervju-listen',
    },

    subscriptionExpired: {
      message: 'Abonnementet er utløpt.',
    },

    stars: {
      yourRating: rating => `Din rating: ${rating}`,
      totalVotes: count => `Totalt ${count} rangeringer`,
      yourRatingReset: 'Tilbakestill din stemme',
    },

    statisticsFilters: {
      timeframe: 'Timeframe',
      owner: 'Owner',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: 'Open job count',
      interviewsLabel: 'Interviews',
      applicationsLabel: 'Applications',
      answersLabel: 'Interview answers',
      activeUsersLabel: 'Active users',
      avgLeadTimeLabel: 'Average lead time',
      avgLeadTimeValue: value => `${value} days`,
    },

    status: {
      opening: {
        open: 'Åpen',
        filled: 'Bemannet',
        cancelled: 'Avbrutt',
        closed: 'Lukket',
        draft: 'Utkast',
        hidden: 'Skjult',
        unpublished: 'Ikke publisert',
      },
      person: {
        hired: 'Ansatt',
        proceed: 'Fortsett',
        new: 'Ny',
        videointerviewed: 'Videointervju',
        interview: title => `Videointervju: ${title}`,
        personalinterview: 'Personlig intervju',
        withdrawn: 'Trukket',
        scheduledinterview: 'Planlagt intervju',
        rejected: 'Avvist',
      },
    },

    trialBanner: {
      notification: days => `Du har ${days} dager igjen av prøveperioden din. Hvis du fortsatt ønsker tjenesten etter prøveperioden, vennligst kjøp abonnement eller enkeltleie.`,
      trialEnded: 'Din prøveperiode er nå avsluttet. Vennligst kjøp abonnement eller enkeltleie for å forsette bruk av tjenesten.',
      orderHere: 'Abonner her!',
    },

    favorite: {
      popupHeader: 'Velg videobibliotek',
      yourVideos: 'Dine videoer',
      companyVideos: 'Selskapets videoer',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Legg videoer til dine favoritter ved å klikke på hjerte-ikonet. Du kan fjerne videoer fra dine favoritter ved å besøke <a href="${videoLibrary}">Videobiblioteket</a>.`,
    },

    brandingPreview: {
      preview: 'Forhåndsvisning',
      header: 'Eksempel på overskrift',
      body: lorem => `Dette er et eksempel på tekstskrift. ${lorem}`,
      linkText: 'Dette er et eksempel på en link',
      primaryButtonText: 'Primærknapp',
      secondaryButtonText: 'Sekundærknapp',
      backButtonText: 'Tilbakeknapp',
    },

    usersList: {
      generalInformation: 'Generell informasjon',
      latestVisit: date => `Siste besøk ${date}`,
      neverLogger: 'Aldri innlogget',
      externalUser: 'Ekstern bruker',
      inviteExpired: 'Invitasjon utløpt',
      permissions: {
        permissions: 'Tillatelser',
        seeAllPositions: 'Se alle stillinger',
        createJobPositions: 'Opprett arbeidsstilling',
        createInterviews: 'Opprett intervjuer',
        account: 'Rediger firmainformasjon',
        billing: 'Fakturering',
        reporting: 'Rapportering',
        editUsers: 'Rediger brukere',
        default: 'Standardtillatelser',
      },
      actions: {
        actions: 'Handlinger',
        activate: 'Aktiver',
        deactivate: 'Deaktiver',
        removeFromOrganisation: 'Fjern fra organisasjonen',
        hiddenPositions: 'Skjulte stillinger',
      },
      noUsers: 'Ingen brukere. Hvis du filtrerte listen, kan du forsøke å redusere antall filtre.',
    },

    usersListFilters: {
      sort: {
        name: 'Navn',
        email: 'E-post',
        lastAdminAccess: 'Siste administratorinnlogging',
      },
      find: 'Søk',
      clearSelections: 'Fjern valg',
      usersCount: count => `Totalt ${count} brukere`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Rediger tillatelser for flere brukere',
      deactivateSelectedUsers: 'Deaktiver valgte brukere',
      activateSelectedUsers: 'Aktiver valgte brukere',
      addNewUsers: 'Inviter brukere',
      save: 'Lagre',
      cancel: 'Avbryt',
      editUsersPermissions: 'Rediger brukernes tillatelser',
    },

    linkedInInformation: {
      title: 'LinkedIn-informasjon:',
      since: 'Siden',
      summary: 'Oppsummering:',
      fullLinkedInProfile: 'Fullstendig LinkedIn-profil',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-postmeldingen ble returnert. Bekreft at mottageren mottok meldingen din.',
      },
      Permanent: {
        General: 'E-postleveringen mislyktes. Mottagers e-postleverandør avviste meldingen.',
        NoEmail: 'E-postadressen eksisterer ikke.',
        Suppressed: 'E-posten ble ikke levert grunnet tidligere mislykkede leveringsforsøk.',
      },
      Transient: {
        General: 'E-postmeldingen ble returnert. Bekreft at mottageren mottok meldingen din.',
        MailboxFull: 'Mottagers e-postkasse er full.',
        MessageTooLarge: 'Meldingsinnholdet er for stort.',
        ContentRejected: 'Meldingsinnholdet ble avvist.',
        AttachmentRejected: 'Vedlegget ble avvist.',
      },
    },

    videoBackgroundUpload: {
      header: 'Organisasjonens videobakgrunnsbilde',
      description:
        'Bilde som organisasjonens brukere kan bruke som bakgrunnsbilde for videoene de spiller inn.',
      add: 'Legg til bakgrunnsbilde for video',
      info: 'Anbefalt bildestørrelse er 720x480 piksler.',
    },
  },

  page: {
    account: {
      title: 'Kontostyring',
      details: 'Kontoopplysninger',
      name: 'Kontonavn',
      save: 'Lagre',
      saved: 'Kontoopplysninger lagret.',
      signature: 'Signatur',
      permissions: 'Tillatelser',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'Passord',
      statistics: 'Statistics',
      organization: 'Organisasjon',
    },

    actionBar: {
      selection: 'valgt',
    },

    organisationProfile: {
      title: 'Organisasjonsprofil',
      details: 'Innstillinger for organisasjonsprofil',
      brandingHeader: 'Organisasjonsprofilering',
      name: 'Organisasjonsnavn',
      owner: 'Kontoeier',
      customReplyToSubtitle:
        'Her kan du redigere avsendernavn og svaradresse for intervjuinvitasjonene. Hvis den er tom, brukes navnet og e-postadressen til brukeren som sender invitasjonene.',
      customReplyToEmail: 'E-postsvar for intervjuinvitasjoner',
      customReplyToName: 'Avsendernavn for intervjuinvitasjoner',
      senderInfoDisabled:
        'Oppdatering av avsenderinformasjonen for intervjuinvitasjonen er deaktivert fordi videointervjuer er deaktivert for din organisasjon.',
      slug: 'Bemanningssidens URL',
      slugUnavailable: 'Denne URL er allerede reservert',
      slogan: 'Bemanningssidens motto',
      language: 'Bemanningssidens språk',
      languagePlaceholder: 'Velg',
      rss: 'Bemanningssidens RSS-feed',
      type: 'Kontotype',
      types: {
        free: {
          title: 'Gratis',
          description: 'Fordeler med gratis\n1 bruker\n1 åpen jobbstilling om gangen',
        },
        basic: {
          title: 'Grunnleggende',
          description: 'Fordeler med gratis\nUbegrensede åpne jobbstillinger\nVideointervjuer',
        },
        team: {
          title: 'Team',
          description: 'Fordeler med team\nUbegrensede åpne jobbstillinger\nVideointervjuer\nKandidatpresentasjoner',
        },
      },
      save: 'Lagre',
      reset: 'Reset',
      companyAdminUsers: 'Company admin users',
      saved: 'Organisasjonsinformasjon lagret.',
      cancel: 'Avbryte',
      confirmLeave: 'Du har ulagrede endringer. Er du sikker på at du vil avbryte?',
      error: {
        required: '* Feltene merket med stjerne er obligatoriske.',
      },
      emailBrandingHeader: 'Profilmerking for e-post',
      emailBrandingDescription:
        'Tilpass fargene på e-postene som sendes til kandidatene.',
    },

    organisationCompetencies: {
      title: 'Organisasjonens kompetanser',
      description: 'Du kan redigere, legge til og slette organisasjonskompetanser her. Dette vil være standardkompetansen i nye stillinger som er opprettet under dette selskapet, og kan bli funnet hos kandidater i disse stillingene i "Kompetanse og kompatibilitet" -delen.',
    },

    organisationStages: {
      title: 'Organisasjonens rekrutteringsstadier',
      description: 'Du kan redigere, legge til, slette eller endre rekkefølgen på organisasjonens stadier her. Disse kommer til å være standard rekrutteringsstadier for nye stillinger denne bedriften oppretter.',
    },

    organisationEvaluationScales: {
      language: 'Språk',
      name: 'Navn',
      description: 'Beskrivelse',
      resetToDefaults: 'Tilbakestill til standardverdier',
      confirmLanguageChange:
        'Er du sikker på at du ønsker å endre språket? Alle endringer som ikke er lagret går tapt.',
    },

    organisationEmailTemplates: {
      preview:
        'Forhåndsvis e-posten (forhåndsvisningen har ikke all formateringen til den endelige e-posten)',
      preview2:
        'Farger for e-postmaler kan tilpasses på organisasjonens innstillingsside for merkevarens profil.',
      timedInterviewPreviewInfo:
        'Meldingen for tidsbestemt videointervju inneholder ikke delen om å kontakte kundestøtten.',
      templateTypes: {
        interviewInvite: 'Invitasjon til videointervju',
        timedInterviewInvite: 'Tidsbestemt videointervjuinvitasjon',
        interviewCompleted:
          'Intervjuet er fullført / takkemelding til kandidatene',
        applicationCompleted:
          'Jobbsøknad fullført / takkemelding til søkeren av stillingsannonsen',
      },
      subHeaders: {
        jobAdLabel: 'Stillingsannonse',
        interviewLabel: 'Videointervju',
      },
      deleteTemplate: 'Slett mal',
      confirmation: templateName =>
        `Er du sikker på at du vil slette malen' ${templateName}" fra organisasjonens e-postmaler?`,
      deleteSuccess: 'Malen ble slettet fra organisasjonens e-postmaler.',
      emailTemplateInfo: 'For øyeblikket kan du bare lagre én mal med ett språk.',
      templateError: 'Mal med samme navn eller språk finnes allerede.',
    },

    application: {
      back: 'Tilbake til søknadslisten',
      delete: 'Slette søknad',
      deleted: 'Søknaden slettet',
      interviewClosed: 'Intervju er stengt',
      resendInvitation: 'Resende invitasjonen til søker',
      changeStage: 'Flytt til et annet nivå',
      commentsAndClassifications: 'Kommentarer og klassifiseringer',
      openingTitle: title => `Videointervju - ${title}`,
      yourRatingText: 'Din rating:',
      competencesAndCompatibility: 'Kompetanse og kompatibilitet',
      duplicateCompetency: 'Kompetanse som allerede finnes',
      competencyNotFound: 'Kompetanse som ikke er funnet eller er fjernet',
      confirmDelete: 'Er du sikker på at du ønsker å slette denne søknaden?',
      lastSeen: time => `sist sett ${time}.`,
      stageChangedInfo: stage => `Nå som du har flyttet disse kandidatene til nivået "${stage}” kan du la dem få vite det! \n\n Send dem en e-post eller en videomelding.`,
      stageChanged: 'Flott!',
      close: 'Lukke',
      reopenProcessConfirm: 'Er du sikker på at du ønsker å flytte denne kandidaten vekk fra stadiet "Trukket", og tilbake til rekrutteringsprosessen? Etter at dette er bekreftet, vil kandidaten igjen kunne svare på ethvert intervju som ikke har blitt fullført enda.',
      withdrawConfirm: 'Er du sikker på at du ønsker å trekke denne kandidaten fra rekrutteringsprosessen? Dersom de blir trukket, vil kandidaten ikke lenger kunne svare på intervjuer de var invitert til.',
      changestageTooltip: 'Du kan se gjeldende stadie hvor kandidaten er. Du kan manuelt angi stadium ved å klikke på ønsket stadium. Kandidaten varsles ikke om dette.',
      commentsTooltip: 'Du kan etterlate kommentarer om kandidatens søknad, som kollegaene dine kan se. Kandidaten har ikke tilgang til denne informasjonen.',
      competencesTooltip: 'Du kan legge til eller vurdere en kompetanse. Kollegaene dine kan se og vurdere kompetanser du har lagt til, og de kan opprette nye. Kandidaten kan ikke se denne informasjonen.',
      actionlogTooltip: 'Kommentarer, sceneendringer, meldinger og andre aktiviteter vil vises her. Kandidaten kan ikke se denne informasjonen.',
      stage: {
        new: 'Ny',
        hired: 'Bemannet',
        proceed: 'Fortsett',
        personalinterview: 'Personlig intervju',
        withdrawn: 'Trukket',
        scheduledinterview: 'Planlagt intervju',
        rejected: 'Avvist',
        videointerviewed: 'Videointervju',
      },
      state: {
        invited: 'Invitert',
        visited: 'Besøkt',
        incomplete: 'Ikke fullført',
        completed: 'Fullført',
      },
      notVisited: 'Har ikke vært på intervju.',
      deadline: date => `Frist: ${date}`,
      deadlineExpired: 'Fristen har passert',
    },

    billing: {
      title: 'Fakturering',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `Neste faktura vil være på ${nextBillingPeriodAmount} EUR den ${nextBillingDate}`,
      status: 'Status',
      singleHire: 'Enkeltleie',
      billingOverview: 'Faktureringsoversikt',
      payment: 'Betaling',
      paymentHistory: 'Betalingshistorikk',
      updateDetails: 'Oppdater faktureringsdetaljer',
      billingStatus: {
        pending: 'Ventende',
        active: 'Aktive',
        pastdue: 'Forfalt',
        expired: 'Utgått',
        canceled: 'Avlyst',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Handling log',
      back: 'Tilbake til kandidatlisten',
      delete: 'Slette kandidat',
      deleted: 'Kandidat slettet',
      interviewClosed: 'Intervju er stengt. Ingen invitasjoner ble sendt på nytt.',
      resendInvitation: 'Resende invitasjonen til kandidater',
      changeStage: 'Flytt til et annet nivå',
      introducedTo: 'Introdusert til:',
      yourRatingText: 'Din rating:',
      competencesAndCompatibility: 'Kompetanse og kompatibilitet',
      duplicateCompetency: 'Kompetanse som allerede finnes',
      competencyNotFound: 'Kompetanse som ikke er funnet eller er fjernet',
      confirmDelete: 'Er du sikker på at du ønsker å slette denne kandidaten?',
      stageChangedInfo: stage => `Nå som du har flyttet disse kandidatene til nivået "${stage}” kan du la dem få vite det! \n\n Send dem en e-post eller en videomelding.`,
      stageChanged: 'Flott!',
      close: 'Lukke',
      hideStages: 'Skjul nivåer',
      showStages: 'Vis nivåer',
      resetQuestionResponseSuccess: 'Kandidatens svar ble slettet',
      stage: {
        new: 'Ny',
        hired: 'Bemannet',
        proceed: 'Fortsett',
        personalinterview: 'Personlig intervju',
        withdrawn: 'Trukket',
        scheduledinterview: 'Planlagt intervju',
        rejected: 'Avvist',
        videointerviewed: 'Videointervju',
      },
      summaryOfAllAnswers: 'Summary of all answers',
      summaryOfAllAnswersInsights: 'Summary of all insights',
    },

    dashboard: {
      upcomingLiveInterviews: 'Live interviews',
      showAllLiveInterviews: 'Show all live interviews',
      createNewLiveInterview: 'Create new live interview',
      interviewRounds: 'Interview rounds',
      interviewGuides: 'Interview guide templates',
      welcome: name => `Velkommen, ${name}!`,
      createNewGuide: 'Create new interview guide template',
      liveCard: {
        startTime: 'Start time',
        interviewers: 'Interviewers',
        candidates: 'Candidates',
      },
      interviewRoundCard: {
        interviews: 'Interviews',
        admins: 'Admins',
        endTime: 'Open until',
      },
      oldLivesLinkText: 'Old live interviews',
    },

    interviewEdit: {
      title: 'Tittel',
      titleLabel: 'Intervjutittel',
      location: 'Sted',
      publishTimePlaceholder: 'Publiseringsdato',
      publishTimeTooltip: 'Angi en publiseringsdato for intervjuet. Du kan endre datoen når du ønsker.',
      endTime: 'Åpen til',
      endTimeTooltip: 'Velg en frist for søknadsperioden.',
      candidateAnswerTimeDays: 'Dager for å sende inn svar',
      candidateAnswerTimeDaysTooltip: 'Angi hvor mange dager hver kandidat har på å fullføre intervjuet etter å ha blitt invitert. Hvis en publiseringsdato er satt, beregnes fristen fra publiseringsdatoen. Hvis intervjuets sluttid er tidligere enn den beregnede fristen for kandidaten, brukes sluttiden i stedet.',
      candidateAnswerTimeDaysTooltipWithoutPublishTime: 'Angi hvor mange dager hver kandidat har på å fullføre intervjuet etter å ha blitt invitert. Hvis intervjuets sluttid er tidligere enn den beregnede fristen for kandidaten, brukes sluttiden i stedet.',
      candidateAnswerTimeDaysPlaceholder: 'Dager for å sende inn svar er ikke angitt',
      candidateAnswerTimeDaysInvalid: 'Verdien må være minst 1',
      unsetCandidateAnswerTimeDays: 'Fjern',
      saveCandidateAnswerTimeDays: 'Lagre',
      timezone: 'Tidssone',
      isNotPastDate: 'datoen er passert.',
      interviewIsClosed: 'Intervjuet er lukket. Ønsker du å ',
      interviewIsClosedLink: 'åpne det',
      edit: {
        details: 'Rediger opplysninger',
        status: 'Endre status',
        team: 'Redigere team',
      },
      questions: 'Intervjuspørsmål',
      answerable: 'Spørsmålet kan besvares',
      required: 'Svar er påkrevd',
      questionsDescription: 'Dette er spørsmålene deltakerne bes besvare.',
      questionsNotEditable: 'Spørsmål kan ikke redigeres etter at invitasjonene er sendt.',
      saved: 'Intervju lagret',
      deleted: 'Intervju slettet',
      delete: 'Slette intervju',
      cancel: 'Avbryte',
      save: 'Lagre',
      language: 'Intervjuspråk',
      languagePlaceholder: 'Velg',
      languages: {
        en: 'Engelsk',
        fi: 'Finsk',
      },
      confirmLeave: 'Du har ulagrede endringer. Er du sikker på at du vil avbryte?',
      OnboardingHeadImageSize: 'Anbefalt størrelse på overskriftsbanneret er 1440x320 piksler eller høyere.',
      takeLimitLabel: 'Antall innspillingsforsøk',
      answerTimeLabel: 'Besvaringstid',
      preparationTimeLabel: 'Forberedelsestid',
      confirmHeader: 'Er du sikker på at du ønsker å slette dette intervjuet?',
      integratedConfirmContent: 'Dette intervjuet er integrert i et annet system, og å fjerne det kan føre til problemer med integrasjonen.',
      evaluationCriteriaLabel: 'Vurderingskriterier',
    },

    interview: {
      endTime: date => (date ? `til ${date}` : ''),
      edit: 'Rediger opplysninger',
      copy: 'Kopier jobbstilling',
      editInvitation: 'Rediger invitasjonsmeldingen',
      editTeam: 'Redigere team',
      editMenu: 'Rediger',
      questions: 'Intervjuspørsmål',
      changeStatus: 'Endre status',
      publishSettings: 'Publiseringsinnstillinger',
      invite: 'Invitere kandidater',
      showCandidates: 'Vise kandidater',
      oneError: ' Innebygget intervju kan kun ha ett spørsmål.',
      copySuccess: 'Jobbstillingen ble vellykket kopiert',
      editIntroduceBatches: 'Rediger introduksjoner',
      editEmailSettings: 'Rediger e-postinnstillinger',
    },

    interviews: {
      allInterviews: 'Alle videointervjuer',
      createNewVideoInterview: 'Lage nytt videointervju',
      filter: 'Søke i intervjuer',
      invites: 'Invitasjoner',
      responses: 'Svar',
      sort: {
        title: 'Tittel',
        endTime: 'Sluttdato',
        publishTime: 'Publiseringsdato',
        createdAt: 'Opprettelsesdato',
        updatedAt: 'Sist endret',
        answeredCount: 'Kandidater',
      },
    },

    interviewCandidates: {
      preview: 'Forhåndsvisning',
      endTime: date => (date ? `Åpen til ${date}` : ''),
      publicTitle: 'Offentlig intervju',
      embedTitle: 'Innebygget intervju',
      placeholder: {
        first: 'Ingen kandidater ennå.',
        second: 'Du kan også gjøre videointervjuet ditt offentlig. Deretter er alle interesserte i stillingen i stand til å se det offentlige intervjuet og søke om det.',
        third: 'Husk at alt dette kun er en knapp unna med tittelfanen ovenfor.',
        fourth: 'Ikke glem at alle disse er bare en knapp unna i tittellinjen over',
      },
      title: 'Alle kandidater',
      sort: {
        default: 'Default',
        updatedAt: 'Sist endret',
        name: 'Navn',
        rating: 'Rangering',
        createdAt: 'Opprettelsesdato',
      },
      sendMessage: 'Send melding',
      changeStage: 'Flytt til et annet nivå',
      introduce: 'Introduser',
      filter: 'Søk i kandidater',
      hideFilters: 'Skjul filtre',
      showFilters: 'Vis filtre',
      emailSent: 'E-post sendt!',
      interviewClosedError: 'Du kan ikke invitere en kandidat til videointervju igjen etter at det er lukket.',
      excel: 'Eksporter alle kandidater',
      reInviteSent: candidates => `${candidates} reinvitasjoner sendt!`,
    },

    jobAdEdit: {
      preview: 'Forhåndsvisning',
      confirm: 'Er du sikker på at du vil legge til denne jobben?',
      deleteHeader: 'Er du sikker på at du vil slette denne jobben?',
      deleteContent: 'Sletting av denne jobben fjerner også all informasjon relatert til stillingen, slik som søknader og videointervjuer.',
      titlePlaceholder: 'Jobbens tittel',
      locationPlaceholder: 'Sted',
      endTimePlaceholder: 'Åpen til',
      endTimeTooltip: 'Velg en frist for søknadsperioden.',
      timezone: 'Tidssone',
      isNotPastDate: 'datoen er passert.',
      publishTimePlaceholder: 'Publiseringsdato',
      publishTimeTooltip: 'Angi en publiseringsdato for stillingsannonsen. Du kan når som helst endre datoen.',
      language: 'Språk',
      languagePlaceholder: 'Velg',
      languages: {
        en: 'Engelsk',
        fi: 'Finsk',
      },
      description: 'Jobb-beskrivelse',
      saved: 'Jobb lagret',
      deleted: 'Jobb slettet',
      descriptionPlaceholder: 'Du kan beskrive jobben her. \n\nDu kan også berike beskrivelsen av tekstformatering verktøy nedenfor.',
      createInviteOnly: 'Lage et videointervju for inviterte',
      delete: 'Slette jobb',
      cancel: 'Avbryte',
      save: 'Lagre',
      confirmLeave: 'Du har ulagrede endringer. Er du sikker på at du vil avbryte?',
      singleHireEndError: 'Enkeltleie kan ikke brukes i mer enn 60 dager.',
      OnboardingHeadImageSize: 'Anbefalt størrelse på overskriftsbanneret er 1440x320 piksler eller høyere.',
    },

    jobAdApplications: {
      endTime: date => (date ? `, åpen til ${date}` : ''),
      title: 'Alle søknader',
      sort: {
        updatedAt: 'Sist endret',
        name: 'Navn',
        rating: 'Rangering',
        createdAt: 'Opprettelsesdato',
      },
      add: 'Lage ny søknad',
      inviteToInterview: 'Inviter til intervju',
      sendMessage: 'Send melding',
      changeStage: 'Flytt til et annet nivå',
      introduce: 'Introduser',
      editIntroduceBatches: 'Rediger introduksjoner',
      filter: 'Søke i søknader',
      hideFilters: 'Skjul filtre',
      showFilters: 'Vis filtre',
      addInterviewConfirm: jobAd => `Ønsker du å lage et nytt videointervju tilknyttet jobb "${jobAd}" ?`,
    },

    adminJobAdApplication: {
      name: 'Navn',
      email: 'E-post',
      phone: 'Telefonnummer',
      city: 'By',
      back: 'Tilbake',
      continue: 'Fortsette',
      submit: 'Legg til',
      namePlaceholder: 'Kandidatens navn',
      emailPlaceholder: 'Kandidatens e-post',
      cityPlaceholder: 'Kandidatens nåværende hjemsted',
      links: 'Legg til linker for eksempel til LinkedIn-profil',
      legendLinks: 'Lenker',
      legendAttachments: 'Vedlegg',
      legendAdditionalFields: 'Tilleggsinformasjon',
      legendBasicInfo: 'Grunnleggende informasjon',
      coverLetter: 'Følgebrev',
      attachments: 'Vedlegg',
      introduction: 'Skriv introduksjonen din her',
      thankYou: 'Mange takk.',
      readyInfo: 'Takk. Kandidaten er nå lagt til i stillingen.',
      close: 'Lukk',
      required: '* Feltene merket med stjerne er obligatoriske.',
      excel: 'Eksporter alle søknade',
    },

    jobAdPreview: {
      endTime: date => (date ? `, åpen til ${date}` : ''),
      exit: 'Avslutte forhåndsvisning',
      description: 'Jobb-beskrivelse',
      video: 'Arbeidsgivervideo',
      questions: 'Videospørsmål',
      apply: 'Søke på stilling',
    },

    jobAd: {
      endTime: date => (date ? `, åpen til ${date}` : ''),
      changeStatus: 'Endre jobbstatus',
      edit: 'Rediger opplysninger',
      copy: 'Kopi av intervju',
      editInvitation: 'Rediger invitasjonsmeldingen',
      editTeam: 'Redigere team',
      editMenu: 'Rediger',
      description: 'Jobb-beskrivelse',
      video: 'Arbeidsgivervideo',
      questions: 'Videospørsmål',
      apply: 'Søke på stilling',
      showApplications: 'Vise søknader',
      publicLink: 'Jobbannonsen offentlig side',
      copySuccess: 'Intervjuet ble vellykket kopiert',
    },

    jobAds: {
      subscriptionNeeded: 'Du trenger et aktivt abonnement for å publisere intervjuet ditt.',
      responses: 'Søknader',
      createNewJobPosition: 'Lage ny jobbstilling',
      allJobPositions: 'Alle jobbstillinger',
      confirmSingleHire: 'En av enkeltleier du har kjøpt er brukt for denne stillingen.',
      filter: 'Søke i jobbstillinger',
      sort: {
        title: 'Tittel',
        publishTime: 'Publiseringsdato',
        applicationCount: 'Søknader',
        endTime: 'Sluttdato',
        createdAt: 'Opprettelsesdato',
        updatedAt: 'Sist endret',
      },
    },

    jobAdSaved: {
      title: 'Jobbstilling lagret!',
      description: 'Jobbannonsen din er nå lagret. Her er en offentlig link til jobbannonsen:',
      addApplication: 'Direktelink til søknadsskjemaet:',
      toDashboard: 'Forside',
      toJobAd: 'Tilbake til jobbannonse',
    },

    interviewGuides: {
      allGuides: 'All interview guide templates',
      createNewGuide: 'Create new interview guide template',
      noResults: 'No interview guide templates found.',
      sort: {
        title: 'Title',
        createdAt: 'Creation date',
      },
    },

    interviewGuide: {
      headerTitle: 'Interview guide',
      titleLabel: 'Interview guide title',
      editTitle: 'Edit interview guide',
      titlePlaceholder: 'Enter interview guide title',
      languageLabel: 'Interview guide language',
      descriptionLabel: 'Description',
      descriptionPlaceholder:
        'Describe the purpose of the interview guide.',
      noDescription: 'No description provided.',
      saved: 'Interview guide saved',
      stepsLabel: 'Interview guide sections',
      stepsSubtitle: 'Define the sections of the interview.',
      deleted: 'Interview guide deleted',
      delete: 'Delete interview guide',
      cancel: 'Cancel',
      save: 'Save interview guide',
      ownerLabel: 'Owner',
      evaluationScale: 'Evaluation scale',
      confirmLeave:
        'You have unsaved changes. Are you sure you want to leave this page?',
      confirmHeader: 'Are you sure you want to delete this interview guide?',
    },

    interviewRounds: {
      allRounds: 'All interview rounds',
      createNewRound: 'Create new interview round',
      noResults: 'No interview rounds found.',
      total: (count) => `${count} interview rounds`,
      sort: {
        title: 'Title',
        createdAt: 'Creation date',
        updatedAt: 'Last modified',
        endTime: 'Open until',
        owner: 'Owner',
      },
    },

    interviewRound: {
      languageAndGuideInfoTextTitle:
        'The interviews belonging to this round will all use the interview guide and language you select here.',
      languageAndGuideInfoText:
        "The language and the guide cannot currently be edited per interview. The interview round's guide and language cannot be edited after you have invited candidates to this round.",
      selectedCandidatesInfoText:
        'Some of the selected candidates have already been invited. If you want to reschedule, open the candidate page.',
      closedWarningText: 'Interview round status is currently "closed". Do you want to ',
      closedLinkText: 'change it to "open"?',
      addCandidatesTitle: 'Legg til kandidater',
      candidatesAdded: (count) => `${count} kandidater tilføjet til interview runde.`,
      existingCandidates: (count) => `${count} kandidater var allerede i interview runden.`,
      scheduleInterview: 'Planlegg intervju',
      headerTitle: 'Interview round',
      titleLabel: 'Interview round title',
      languageLabel: 'Interview round language',
      endTimeLabel: 'Open until',
      timezoneLabel: 'Time zone',
      editTitle: 'Edit interview round',
      titlePlaceholder: 'Enter interview round title',
      interviewGuideLabel: details => details
        ? 'Interview guide'
        : 'Select interview guide template for the interview',
      noGuide: 'No interview guide template selected',
      noGuidesForLanguage: 'No interview guides available for the selected language',
      saved: 'Interview round saved',
      deleted: 'Interview round deleted',
      candidatesInvited: 'Candidates invited.',
      delete: 'Delete interview round',
      cancel: 'Cancel',
      save: 'Save interview round',
      ownerLabel: 'Owner',
      confirmLeave:
        'You have unsaved changes. Are you sure you want to leave this page?',
      confirmHeader: 'Are you sure you want to delete this interview round?',
      removeGuide: 'Clear guide',
      noCandidates: 'No interviews yet.',
      changeStatus: 'Change interview round status',
      sort: {
        updatedAt: 'Sist endret',
        startTime: 'Starttid for intervjuet',
        name: 'Navn',
        lastAccess: 'Sist tilgått',
        createdAt: 'Opprettelsesdato',
      },
    },

    interviewInsights: {
      header: 'Interview Insights',
      statisticalAnalysis: 'Statistical analysis',
      overallFeedback: 'Overall feedback',
      detailedFeedback: 'Detailed feedback',
      compliance: 'Compliance',
      complianceIssue: 'Compliance issue',
      close: 'Close',
      speakingTime: 'Speaking time',
      candidate: 'Candidate',
      interviewer: 'Interviewer',
      interviewersMultiple: 'Interviewers',
      adherence: {
        timeTable: 'Adherence to time table',
        sections: 'Adherence to section times',
        questions: 'Adherence to questions',
        talkRatio: 'Speaking time distribution',
      },
      readMore: 'Read more',
      analysis: 'Analysis',
      sections: 'Sections',
      details: 'Detailed feedback',
      proposedNextSteps: 'Proposed next steps',
      analysisInProgress: 'Insights analysis in progress...',
      analysisFailed: 'Error loading insights analysis.',
      tryAgainLater: 'Please try again later.',
      legalContext: 'Legal context',
    },

    live: {
      interviewersInfo:
        'When you add interviewers who are not in the interview round admins, they will be added as admins to the interview round.',
      noStartTimeSelected: 'Ingen starttid valgt',
      noInterviewers: 'Ingen interviewere',
      title: 'live-intervju',
      editTitle: 'Rediger live-intervju',
      startTimeTitle: 'Starttidspunkt for intervjuet',
      startTime: 'Starttid',
      notScheduled: 'Ikke planlagt',
      interviewers: 'Interjuvere',
      candidate: 'Kandidat',
      candidates: 'Kandidater',
      candidateDisplayName: `Kandidatens navn`,
      messageLabel: 'Invitasjonsmelding',
      languageLabel: 'Språk',
      create: 'Lage nytt live-intervju',
      save: 'Lagre endringer',
      cancel: 'Avbryt',
      reschedule: 'Reschedule interview',
      schedule: 'Schedule interview',
      removeLive: 'Fjern live-intervju',
      cancelLive: 'Avbryt live-intervju',
      evaluationLabel: 'Evaluering',
      evaluationComparisonLabel: 'Sammenligning av evalueringer',
      comment: 'Legg til en ny kommentar',
      commentLabel: 'Kommentarer',
      enter: 'Gå inn i live-intervjuet',
      interviewInsights: 'Interview Insights',
      continueEvaluation: 'Fortsett evaluering',
      viewRecordings: 'Se opptak',
      transcriptButtonText: 'Intervjuutskrift',
      interviewGuideLabel: details => details
        ? 'Interview guide'
        : 'Select interview guide template for the interview',
      noGuide: 'No interview guide template selected',
      interviewGuideInfo:
        'Du kan bare bruke en intervjuguide når det er én kandidat.',
      edit: 'Rediger intervju',
      draft: 'Nytt live-intervju',
      pending: 'Venter på kandidatbekreftelse',
      scheduledLiveCandidateSubtitle:
        'Du kan bare legge til én kandidat for det planlagte liveintervjuet',
      confirmHeader: 'Er du sikker på at du ønsker å slette dette intervjuet?',
      inviteFailure: (success, failed) => `sendte ${success} invitasjoner og ${failed} mislyktes!`,
      inviteSuccess: success => `sendte ${success} invitasjoner.`,
      recordingsHeaderWithTitle: title => `Opptak for live-intervju ${title}`,
      recordingsHeader: 'live intervjuopptak',
      success: {
        create: 'Nytt live intervju opprettet',
        delete: 'live intervju fjernet',
        update: 'live intervju oppdatert',
      },
      placeholders: {
        candidateEmails: 'Legg til kandidat',
        interviewerEmails: 'Legg til intervjuer',
        emailTitle: 'Tittel',
        emailMessage: 'Melding',
        emailName: 'Navn',
      },
      successInviteSent: 'Interview time selection message sent to candidate.',
      errorInviteNotSent: 'Message could not be sent.',
      startTimeChanged: 'The start time of the interview has been changed.',
      rescheduleConfirmBody: 'Are you sure you want to reschedule this interview?',
      backToRound: 'Back to interview round',
      schedulingInfo:
        "You can use the interview's organisation's users' calendars that are connected to Recright and are interviewers in this interview.",
    },

    lives: {
      allLives: 'Alle live-intervjuer',
      createNewLive: 'Lage nytt live-intervju',
      filter: 'Søk på kandidat',
      candidates: 'Kandidater',
      sort: {
        title: 'Titel',
        startTime: 'Starttid',
        createdAt: 'Opprettelsesdato',
      },
    },

    login: {
      title: 'Logg inn på tjenesten',
      register: 'Registrer',
      forgot: 'Glemt passordet?',
      normal: 'Normal log in',
      ssoLogin: 'SSO-innlogging',
    },

    quickInterview: {
      title: 'Hurtig videointervju',
      description: 'For å bli raskere kjent med deg ber vi om at du gir et kort svar på vårt hurtige intervjuspørsmål. Vis litt personlighet og gi søknaden din sjel.',
      requiredNote: 'Merk at dette er en del av søknadsprosessen. Rekruttereren mottar ikke søknaden din før du har spilt inn svaret ditt.',
      reminderNote: 'Du kan spille inn svaret med en gang, eller du kan fortsette senere ved å motta en påminnelsen til e-posten din.',
    },

    register: {
      title: 'Utformet for rekruttører!',
      leadText: 'Recright er en brukervennlig videorekrutteringsplattform for rekruttører og personalledelse. Du kan publisere ledige stillinger, motta søknader og utføre videointervjuer – alt på samme sted! Verktøyet vårt har hjulet over 400 selskaper med å finne de riktige personene – ditt selskap kan være det neste! Registrer deg nedenfor og start rekrutteringen!',
      email: 'Email',
      submit: 'Registrer deg',
      alreadyMember: 'Allerede medlem?',
      onlyForRecruiters: 'Denne registreringen er kun for rekruttører og personalledelse.',
      login: 'Logg inn her.',
      registerSuccess: 'Sjekk om du har fått e-post, og registrer deg via linken vi har sendt deg.',
      domainError: 'Registrering med e-postadressen til bedriften din.',
      companyExistsMessage: 'Se e-posten din for instruksjoner!',
    },

    searchResults: {
      title: 'Søkeresultater',
      applications: 'Søknader',
      candidates: 'Kandidater',
      noApplications: 'Ingen søknader samsvarer med søkekriteriet',
      noCandidates: 'Ingen kandidater samsvarer med søkekriteriet',
      query: query => (query ? `Søkeemne: ${query}` : ''),
      noStage: 'Ikke i noe nivå foreløpig',
      search: 'Søk',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'See detailed statistics',
      linkToSummary: 'See statistics summary',
      summaryLeadText: 'Figures below comprises of all active positions during the selected time period including the positions that do not have an end date.',
      detailsLeadText: 'This page provides detailed statistics on all positions with any activity during the selected time period.',
      export: 'Export statistics',
      sort: {
        title: 'Tittel',
        owner: 'Owner',
        createdAt: 'Opprettelsesdato',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    welcome: {
      title: 'Registrer deg',
    },

    welcomeMulticompany: {
      welcome: companyName => `Velkommen til ${companyName}`,
      successMessage: companyName =>
        `Du er nå lagt til i organisasjonen ${companyName}!`,
      navigationInfo:
        'Du kan bytte gjeldende aktiv organisasjon fra navigasjonslinjen øverst til høyre.',
      login: 'Logg inn her',
    },

    forgotPassword: {
      title: 'Velg nytt passord',
      email: 'E-post',
      submit: 'Send',
      sendEmail: 'Send oss e-postadressen du brukte til å registrere deg på Recright.',
      instructions: 'Vi sender deg informasjon om hvordan du kan endre passordet.',
      success: 'Hvis brukeren ble funnet med e-postadressen du oppgav, er instruksjonene for å endre passord ditt sendt til denne adressen.',
    },

    changePassword: {
      title: 'Endre passorde',
      name: 'Navn',
      email: 'E-post',
      password: 'Nytt passord',
      confirmPassword: 'Nyt passord igjen',
      submit: 'Endre passord',
      error: {
        password: {
          isRequired: 'Passord er nødvendig. ',
          isValidPassword: 'Et gyldig passord må ha minst 12 tegn og inneholde minst én stor bokstav, én liten bokstav og ett tall.',
          passwordsMatch: 'Passord matcher ikke.',
        },
      },
    },

    ssoLogin: {
      title: 'SSO-innlogging',
      description: 'Logg på med organisasjonens innloggingsopplysninger.',
      info: 'Ekstern autentisering ikke konfigurert. Bruk den',
      normalLoginLinkText: 'vanlige innloggingen.',
      submit: 'Logg inn på tjenesten',
    },

    subscribe: {
      title: 'Abonner',
      submit: 'Abonner',
      creditCard: 'Kredittkort',
      cvv: 'CVV',
      expirationDate: 'Utløpsdato',
      vatAdvice: 'Hvis du oppgir et momsnummer, så vil vi ikke legge merverdiavgift til ordren din.',
      vatId: 'MVA/Tax-ID',
      vatHelp: 'Oppgi ditt MVA-nummer i internasjonalt format, inkludert landskoden.',
      includeVat: 'Inkl. MVA.',
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      email: 'E-post',
      company: 'Selskap',
      street: 'Gate',
      postalCode: 'Postnummer',
      city: 'By',
      country: 'Land',
      emptyCardFields: 'Vennligst fyll ut dine kredittkort-detaljer',
      invalidValue: 'Felt-verdien er ugyldig.',
      planNotSelected: 'Vennligst velg plan',
      totalPrice: 'Totalt',
      subscribed: 'Utrolig! Abonnementet er opprettet.',
      subscriptionExists: 'Din bedrift ser ut til å ha et aktivt abonnement. Vennligst logg inn for å endre ditt abonnement.',
      agreeTos: 'Jeg har lest og godtar ',
      agreeTosLinkText: 'Recrights vilkår og betingelser for bruk.',
      privacyPolicy: 'Vi verdsetter personvernet ditt, les vår ',
      licenseAgreement: 'På vegne av organisasjonen, godtar jeg ',
      licenseAgreementLinkText: 'Recrights generelle tjenestevilkår.',
      privacyPolicyLinkText: 'Personvernerklæring.',
      newsletter: 'Abonner på månedlig nyhetsbrev.',
      neverExpiresDiscount: amount => `Inkludert livstidsrabatt ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) => `Inkludert rabatt ${amount} EUR på ${cycles} måneder`,
      errorFromProcessor: error => `Betalingsbehandler svarte med feil: ${error}`,
    },

    videos: {
      title: 'Videobibliotek',
      add: 'Lage nytt video',
      rename: 'Endre navn',
      remove: 'Fjerne',
      yourVideos: 'Dine videoer',
      companyVideos: 'Selskapets videoer',
      confirmDeleteVideoTitle: 'Er du sikker på at du vil slette denne videoen?',
      confirmDeleteVideoMessage: 'Dette vil fjerne videoen fra biblioteket og alle Collections.',
      addToCollection: 'Legg til i samling',
    },

    userManagement: {
      excel: 'Eksporter alle brukere',
      title: 'Brukeradministrasjon',
      showCompanyDefaultPermissions: 'Vis firmaets standardtillatelser',
      activateUserConfirm: 'Er du sikker på at du vil aktivere denne brukeren?',
      deactivateUserConfirm: 'Er du sikker på at du vil deaktivere denne brukeren?',
      showActivatedUsers: 'Vis aktive brukere',
      showDeactivatedUsers: 'Vis deaktiverte brukere',
      confirmCancelEditPermissions: {
        message: 'Du har endringer som ikke er lagret. Er du sikker på at du vil forkaste alle endringer?',
        cancel: 'Avbryt',
        confirm: 'Forkast endringer',
      },
      unsavedChanges: 'Du har endringer som ikke er lagret. Vil du lagre disse endringene?',
      confirm: 'Lagre',
      permissionsChangesSaved: 'Brukertillatelsene ble lagret!',
      userDeactivated: nameOrEmail => `${nameOrEmail} deaktivert`,
      userActivated: nameOrEmail => `${nameOrEmail} aktivert`,
      companyDefaultsSaved: 'Standard administratortillatelser ble endret!',
      usersAddAdded: success => `${success} brukere lagt til.`,
      usersAddExist: exist => ` ${exist} brukere er allerede i Recright.`,
      excel: 'Eksporter alle brukere',
    },

  },

}
